import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { ToWords } from 'to-words'
import { Modal, Navbar, Nav } from 'react-bootstrap';
import { Tooltip } from "antd";
import { v1 as uuid } from 'uuid';

import { getCookie } from '../common_component/cookie.js';
import { useAuthData } from "./auth-provider.js"
import StatusBadge from '../common_component/StatusBadge.js';
import formatNumber from '../common_component/formatNumber.js';
import PageError from '../common_component/PageError.js';

export const ViewCustomerInvoice = (props) => {
	const [customerInvoiceDetails, setCustomerInvoiceDetails] = useState([]);
	const [customerInvoiceHistoryDetails, setCustomerInvoiceHistoryDetails] = useState([]);
	const [customerInvoicePaymentDetails, setCustomerInvoicePaymentDetails] = useState([]);
	const [branchList, setBranchList] = useState([])
	const [noOfCopies, setNoOfCopies] = useState(1);

	const [printPdfTemplate, setPrintPdfTemplate] = useState("")
	const [printBillTemplate, setPrintBillTemplate] = useState("")
	const [printModalShow, setPrintModalShow] = useState(false)
	const [downloadModalShow, setDownloadModalShow] = useState(false)
	const [loading, setLoading] = useState(false);

	const [itemTab, setItemTab] = useState('orderedItems');
	const [itemDetails, setItemDetails] = useState([]);
	const [taxDetails, setTaxDetails] = useState([]);
	const [billingAddress, setBillingAddress] = useState({});
	const [shippingAddress, setShippingAddress] = useState({});
	const [gstDetails, setGstDetails] = useState({});

	const [invoiceCurrencyDetails, setInvoiceCurrencyDetails] = useState(null)

	const [adjustmentValue, setAdjustmentValue] = useState("");
	const [adjustmentText, setAdjustmentText] = useState("");

	const [subTotal, setSubTotal] = useState(0)

	const [image, setImage] = useState("");

	const [state, setstate] = useState(2);
	const history = useHistory()

	const [warehouseDetails, setWarehouseDetails] = useState(null)
	const [warehouseItemArray, setWarehouseItemArray] = useState([])

	const [itemsModalShow, setItemsModalShow] = useState(false)
	const [itemsData, setItemsData] = useState([])

	const [invoiceStatus, setInvoiceStatus] = useState(null)
	const [invoiceStatusModalShow, setInvoiceStatusModalShow] = useState(false)
	const [invoiceStatusApiState, setInvoiceStatusApiState] = useState(false)
	const [mainSubmitButtonState, setMainSubmitButtonState] = useState(false)

	const [approvalChainPopup, setApprovalChainPopup] = useState(false)

	const [approveFinalButtonShow, setApproveFinalButtonShow] = useState(false)
	const [approveButtonShow, setApproveButtonShow] = useState(false)
	const [cancelButtonShow, setCancelButtonShow] = useState(false)

	const [submitButtonState, setSubmitButtonState] = useState(false);
	const [customerDeliveryChallanList, setCustomerDeliveryChallanList] = useState([]);

	var page_name = "view-customer-invoice";

	const { user, read, write, visibility, organization_id, user_role, organization_name, contact_details, organization_address } = useAuthData(page_name)

	const loaderstyle = {
		display: "block",
		marginLeft: "auto",
		marginRight: "auto",
		marginTop: "auto",
		marginBottom: "auto",
	};

	let formatNumberOptions = {
		removeTrailingZeros: true
	}

	const generateUID = () => {
		const time = Date.now().toString(36);
		const random = Math.random().toString(36).substring(2, 10);
		return `${time}${random}`.slice(0, 16);
	};

	const htmlUidRef = useRef(null);

	if (!htmlUidRef.current) {
		htmlUidRef.current = generateUID();
	}

	const html_uid = htmlUidRef.current;


	async function getCustomerInvoiceDetails() {
		const response = await fetch(
			`${process.env.REACT_APP_SERVER_URL}/get-customer-invoice-details`, { method: 'POST', body: JSON.stringify({ "email": user.email, "customer_invoice_id": props.match.params.id, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
		);
		const body = await response.json();
		// console.log(body.data);

		if (body.operation === "success") {
			if (body.data.length > 0) {
				setCustomerInvoiceDetails(body.data[0]);
				if (user_role == "Admin") {
					setApproveFinalButtonShow(true)
					setCancelButtonShow(true)
				}

				let t1 = body.data[0].approval_info
				let t2 = body.data[0].add_status
				let t3 = body.data[0].approval_level
				// let t4 = t1.value.length
				if (t2 == "CUSTOMER_INVOICE_PENDING_APPROVAL") {
					if (t1.type == "multilevel_approval") {

						let tl = t1.value.find(x => x.level == (t3 == null ? 1 : t3 + 1)).user_value
						if (tl.includes(user.email)) {
							setApproveButtonShow(true)
						}

						let tl2 = t1.value.map(x => x.user_value).flat(1)
						if (tl2.includes(user.email)) {
							setCancelButtonShow(true)
						}
					}
					else if (t1.type == "custom_approval") {
						let ty = t1.value[0]
						if (ty.user_type == "Group User") {
							if (ty.user_value.includes(user_role)) {
								setApproveButtonShow(true)
								setCancelButtonShow(true)
							}
						}
						else if (ty.user_type == "Individual User") {
							if (ty.user_value.includes(user.email)) {
								setApproveButtonShow(true)
								setCancelButtonShow(true)
							}
						}
					}
				}

				setInvoiceCurrencyDetails(body.data[0].invoice_currency)

				setAdjustmentValue(body.data[0].adjustment.value);
				setAdjustmentText(body.data[0].adjustment.text);

				let temp = body.data[0].item_array;
				setItemDetails(temp);

				let arr = [];
				temp.forEach((obj, index) => {
					if (obj.taxable == 0) {
						obj.taxable_amount = 0;
					}
					else {
						obj.total_taxable_amount = (((obj.quantity * obj.rate) - (obj.discount_type == "amount" ? obj.discount_unit : obj.quantity * obj.rate * obj.discount_unit / 100)) * (obj.tax_group_percentage / 100))
						obj.taxable_amount = Number(obj.rate) * obj.tax_group_percentage / 100;
					}

					if (obj.tax_calculation_method == "TAX_Exclusive") {
						obj.TAX_Inclusive_Price = Number(obj.rate) + obj.taxable_amount;
						obj.TAX_Exclusive_Price = obj.rate;
					}
					else {
						obj.TAX_Inclusive_Price = Number(obj.rate) + obj.taxable_amount;
						obj.TAX_Exclusive_Price = obj.rate;
					}

					obj.total_tax = obj.tax_group_details == null ? 0 : obj.tax_group_details.reduce((p, o) => { return p + Number(o.tax_percentage) }, 0);
					if (obj.tax_group_details != null) {
						obj.tax_group_details.map((obj1, index1) => {
							if (arr.find(x => x.tax_id == obj1.tax_id)) {
								let p = arr.find(x => x.tax_id == obj1.tax_id);
								p.tax_amount = p.tax_amount + (Number(obj.total_taxable_amount) * Number(obj1.tax_percentage) / Number(obj.total_tax))
							}
							else {
								let json = {};
								json.tax_id = obj1.tax_id;
								json.tax_type = obj1.tax_type;
								json.tax_name = obj1.tax_name;
								json.tax_percentage = obj1.tax_percentage;
								json.tax_amount = (Number(obj.total_taxable_amount) * Number(obj1.tax_percentage) / Number(obj.total_tax))
								arr.push(json);
							}
						});
					}
				})
				setTaxDetails(arr);

				setSubTotal(body.data[0].item_array.reduce((p, o) => { return (p + (((o.quantity * o.rate) - (o.discount_type === "amount" ? o.discount_unit : o.quantity * o.rate * o.discount_unit / 100)) + (o.taxable === 0 ? 0 : ((o.quantity * o.rate) - (o.discount_type === "amount" ? o.discount_unit : o.quantity * o.rate * o.discount_unit / 100)) * (o.tax_group_percentage / 100)))); }, 0));
				setBillingAddress(body.data[0].billing_address);
				setShippingAddress(body.data[0].shipping_address);
				setGstDetails(body.data[0].gstin_details);

			}
			else {
				throw new Error("get customer invoice api error", { cause: "api error" })
			}
		}
		else {
			throw new Error(body.message, { cause: "api error" })
		}
	}

	const getInvoiceStatus = async (invoice_id) => {
		setInvoiceStatusApiState(false)
		const response = await fetch(
			`${process.env.REACT_APP_SERVER_URL}/get-customer-invoice-status`, { method: 'POST', body: JSON.stringify({ "email": user.email, "invoice_id": invoice_id, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
		);
		const body = await response.json();

		setInvoiceStatus(body);
		setInvoiceStatusApiState(true);
	}

	async function getInvoiceHistorydetails() {
		const response = await fetch(
			`${process.env.REACT_APP_SERVER_URL}/get-customer-invoice-history-details`, { method: 'POST', body: JSON.stringify({ "email": user.email, "customer_invoice_id": props.match.params.id, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
		);
		const body = await response.json();
		if (body.operation === "success") {
			setCustomerInvoiceHistoryDetails(body.data);
		}
	}

	async function getInvoicePaymentdetails() {
		const response = await fetch(
			`${process.env.REACT_APP_SERVER_URL}/get-customer-invoice-payment-details`, { method: 'POST', body: JSON.stringify({ "email": user.email, "customer_invoice_id": props.match.params.id, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
		);
		const body = await response.json();
		if (body.operation === "success") {
			setCustomerInvoicePaymentDetails(body.data);
		}
	}

	const getDefaultBankDetails = async () => {
		try {
			const res = await fetch(`${process.env.REACT_APP_SERVER_URL}/get-default-bank-details`, {
				method: "POST",
				body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }),
				headers: {
					"Content-Type": "application/json",
					token: getCookie("access_token")
				}
			});

			const data = await res.json();
			return data?.data?.[0] || null; // take first default bank
		} catch (err) {
			console.error("Bank fetch failed", err);
			return null;
		}
	};


	async function getBranchList() {
		const response = await fetch(
			`${process.env.REACT_APP_SERVER_URL}/get-branches`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
		);
		const body = await response.json();
		if (body.operation == "success") {
			setBranchList(body.data);
		}
		else {
			throw "branch list api error"
		}
	}

	async function getWarehouseProcessingDetails() {
		const response = await fetch(
			`${process.env.REACT_APP_SERVER_URL}/get-customer-warehouse-processing-details`, { method: 'POST', body: JSON.stringify({ "email": user.email, "customer_invoice_id": props.match.params.id, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
		);
		const body = await response.json();
		// console.log(body);
		if (body.operation === "success") {
			setWarehouseDetails(body.data)
			setWarehouseItemArray(body.data.item_array)
			return body.data.customer_invoice_id
		}
		else if (body.data.length <= 0) {
			// console.log("Continue to warehouse to see item details")
			return null
		}
		else {
			console.log("Invalid Warehouse Processing")
			return null
		}
	}

	async function getCustomerInvoiceTemplate() {
		try {
			const response = await fetch(
				`${process.env.REACT_APP_SERVER_URL}/get-customer-invoice-pdf-template`, { method: 'POST', body: JSON.stringify({ "email": user.email, "category_type": "customer_invoice", "format_type": "pdf_type", "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
			);
			const body = await response.json();

			if (body.operation === "success") {
				setPrintPdfTemplate(body.data);
			} else {
				throw "Invoice template API error";
			}
		} catch (error) {
			console.error("Invoice template API call:", error);
		}
	}

	async function getCustomerInvoiceBillTemplate() {
		try {
			const response = await fetch(
				`${process.env.REACT_APP_SERVER_URL}/get-customer-invoice-bill-template`, { method: 'POST', body: JSON.stringify({ "email": user.email, "category_type": "customer_invoice", "format_type": "bill_type", "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
			);
			const body = await response.json();

			if (body.operation === "success") {
				setPrintBillTemplate(body.data);
			} else {
				throw "invoice template for bill API error";
			}
		} catch (error) {
			console.error("Invoice template for bill API call:", error);
		}
	}

	async function getorganizationdetails() {

		var object = {};
		object.email = user.email;

		const response = await fetch(
			`${process.env.REACT_APP_SERVER_URL}/get-organization-information`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id, "id": organization_id, "flag": "details" }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
		);
		const body = await response.json();
		// let obj = {}
		if (body.length > 0) {
			if ((body[0].file_name) && (typeof body[0].file_name === "string")) {
				setImage(`${process.env.REACT_APP_GENERAL_IMAGE_BUCKET}/organization_logo/${body[0].file_name}`);
			}
		}
		else {
			console.log("Invalid organization image api call")
			return null
		}
	}

	async function getCustomerDeliveryChallanList(customer_invoice_id) {
		const response = await fetch(
			`${process.env.REACT_APP_SERVER_URL}/get-customer-challan-by-invoice-id`, { method: 'POST', body: JSON.stringify({ "email": user.email, "customer_invoice_id": customer_invoice_id, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
		);
		const body = await response.json();

		if (body.operation === "success") {
			setCustomerDeliveryChallanList(body.data);
			console.log(body.data);
		}
	}

	async function getSalesReturnBySearch(customer_id, search_value) {
		try {
			// if (salesReturnListApiState) {
			// 	salesReturnApiController.current.abort()
			// 	salesReturnApiController.current = new AbortController()
			// }
			// setSalesReturnListApiState(true)
			const response = await fetch(
				`${process.env.REACT_APP_SERVER_URL}/get-sales-return-by-search`, { method: 'POST', body: JSON.stringify({ "email": user.email, "customer_id": customer_id, "search_value": search_value, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
			);
			const body = await response.json();

			if (body.operation === "success") {

				// const filteredData = body.data
				// 	.filter(x => Number(x.remaining_quantity) > 0)
				// 	.map(x => ({
				// 		label: x.sales_return_number,
				// 		value: x.sales_return_id,
				// 		customer_invoice: x.customer_invoices?.[0],
				// 		customer_invoice_id: x.customer_invoice_id,
				// 		item_list: x.item_array
				// 	}));

				// setSalesReturnList(filteredData);
				// setSalesReturnListApiState(false);

				return body.data;
			}
		}
		catch (err) {
			if (err.name !== 'AbortError') {
				console.log(err)
			}
		}
	}

	useEffect(() => {
		if ((read || write) && (user.email && visibility)) {

			let p1 = getCustomerInvoiceDetails()
			let p2 = getInvoiceHistorydetails()
			let p3 = getWarehouseProcessingDetails()
			let p4 = getBranchList()
			let p5 = getCustomerInvoiceTemplate()
			let p6 = getCustomerInvoiceBillTemplate()
			let p7 = getorganizationdetails()
			let p8 = getInvoicePaymentdetails()
			let p9 = getCustomerDeliveryChallanList(props.match.params.id)

			Promise.all([p1, p2, p3, p4, p5, p6, p7, p8, p9])
				.then(() => {
					setstate(1);
					console.log("all apis done")
				})
				.catch((err) => {
					setstate(0);
					console.log(err)
				})
		}
	}, [user, visibility, read, write])

	const markAsComplete = () => {

		var object = {}

		object.invoice_id = props.match.params.id;

		object.organization_id = organization_id;
		object.page_name = page_name;

		setMainSubmitButtonState(true)

		var headers = {
			headers: {
				"Content-Type": "application/json",
				"Accept": "*/*",
				"token": getCookie("access_token")
			}
		}

		axios.post(`${process.env.REACT_APP_SERVER_URL}/mark-customer-invoice-as-complete`, object, headers).then((res) => {
			setMainSubmitButtonState(false)
			getCustomerInvoiceDetails();
			setInvoiceStatusModalShow(false)
			if (res.data.operation === "success") {
				swal("Great!", 'The dealer invoice has been successfully marked as completed.', "success")
			}
			else {
				swal("Oops!", res.data.message, "error");
			}
		})
			.catch(function (error) {
				console.log(error)
			});
	}

	const approveInvoiceSubmit = (final_flag, cancel_flag, cancel_msg) => {

		var object = {};

		object.final_flag = final_flag
		object.cancel_flag = cancel_flag
		object.cancel_msg = cancel_msg
		object.customer_invoice_id = props.match.params.id
		object.user_email = user.email
		object.user_role = user_role

		object.organization_id = organization_id
		object.page_name = page_name;

		// console.log(object);
		setSubmitButtonState(true)

		var headers = {
			headers: {
				"Content-Type": "application/json",
				"Accept": "*/*",
				"token": getCookie("access_token")
			}
		}
		axios.post(`${process.env.REACT_APP_SERVER_URL}/approve-customer-invoice`, object, headers).then((res) => {
			setSubmitButtonState(false)
			if (res.data.operation === "success") {
				swal("Great!", "invoice reviewed successfully!", "success").then(() => { history.push("/customer-invoice-list"); })
			}
			else {
				swal("Oops!", res.data.message, "error");
			}
		})
			.catch(function (error) {
				console.log(error)
			});
	}

	async function saveCustomerInvoiceHtmlDetails(html_template, html_uid) {
		try {
			const response = await fetch(
				`${process.env.REACT_APP_SERVER_URL}/save-customer-invoice-html-details`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json; charset=UTF-8",
						"token": getCookie("access_token")
					},
					body: JSON.stringify({
						email: user.email,
						html_uid,
						html_template,
						customer_invoice_id: props.match.params.id,
						page_name,
						organization_id
					})
				}
			);

			if (!response.ok) {
				throw new Error("Network response failed");
			}

			const body = await response.json();

			if (body.operation !== "success") {
				throw new Error("Invoice template API error");
			}

			// silent success (no UI dependency)

		} catch (error) {
			console.error("Invoice template API call failed:", error);
		}
	}

	const getProcessedStockData = async (
		invoiceItems,
		deliveryChallanList,
		salesReturnDetails
	) => {

		/* ------------ 1️⃣ Collect Original Serial/Batch From Challan ------------ */

		const challanMap = {};

		for (const ch of deliveryChallanList) {
			for (const item of ch.item_array) {

				if (!challanMap[item.item_id]) {
					challanMap[item.item_id] = [];
				}

				challanMap[item.item_id].push(
					...(item.item_data || [])
				);
			}
		}

		/* ------------ 2️⃣ Collect Returned (Defective) ------------ */

		const returnedMap = {};

		salesReturnDetails?.forEach(sr => {
			sr.item_array?.forEach(item => {

				if (!returnedMap[item.item_id]) {
					returnedMap[item.item_id] = [];
				}

				item.challan_info?.forEach(ch => {
					returnedMap[item.item_id].push(
						...(ch.returned_item_data || [])
					);
				});
			});
		});

		/* ------------ 3️⃣ Collect Finalized Replacements ------------ */

		const replacedMap = {};

		salesReturnDetails?.forEach(sr => {
			sr.customer_invoice_replacements?.forEach(rep => {

				if (rep.add_status !== "INVOICE_REPLACEMENT_FINALIZED") return;

				rep.item_array?.forEach(item => {

					if (!replacedMap[item.item_id]) {
						replacedMap[item.item_id] = [];
					}

					replacedMap[item.item_id].push(
						...(item.item_data || [])
					);
				});
			});
		});

		/* ------------ 4️⃣ Final Adjusted Result ------------ */

		return invoiceItems.map(invItem => {

			let finalList = [...(challanMap[invItem.item_id] || [])];

			const removed = returnedMap[invItem.item_id] || [];
			const added = replacedMap[invItem.item_id] || [];

			// Remove returned serials/batch
			if (removed.length) {
				finalList = finalList.filter(
					s => !removed.some(r => r.uid === s.uid)
				);
			}

			// Add replaced serials/batch
			if (added.length) {
				finalList = [...finalList, ...added];
			}

			const invoiceQty = Number(invItem.quantity || 0);
			const finalQty = finalList.length;

			return {
				item_id: invItem.item_id,
				serial_list: finalList,
				defective_count: removed.length,
				mismatch_count: invoiceQty - finalQty > 0
					? invoiceQty - finalQty
					: 0
			};
		});
	};

	const waitForImages = (win) => {
		const images = win.document.images;
		if (!images.length) return Promise.resolve();

		let loaded = 0;
		return new Promise(resolve => {
			for (let img of images) {
				if (img.complete) {
					loaded++;
					if (loaded === images.length) resolve();
				} else {
					img.onload = img.onerror = () => {
						loaded++;
						if (loaded === images.length) resolve();
					};
				}
			}
		});
	};

	async function getCustomerInvoiceHtmlDetails(type) {
		const response = await fetch(
			`${process.env.REACT_APP_SERVER_URL}/get-customer-invoice-html-details`, { method: 'POST', body: JSON.stringify({ type, "value": props.match.params.id, "page_name": page_name }), headers: { "Content-type": "application/json; charset=UTF-8" } }
		);
		const body = await response.json();

		if (body.operation === "success") {
			return body.data;
		}
		else {
			throw new Error(body.message, { cause: "api error" })
		}
	}

	const handleOperation = async (operationType) => {
		setMainSubmitButtonState(true);
		const salesReturnDetails = await getSalesReturnBySearch(customerInvoiceDetails.customer_id, customerInvoiceDetails.customer_invoice_id)
		const htmlDetails = await getCustomerInvoiceHtmlDetails("invoice_id");
		const preview_id = htmlDetails ? htmlDetails.html_uid : html_uid;
		const invoicePreviewUrl = `https://app.spoterp.com/invoice-preview/${preview_id}`;
		const invoicePreviewQr = `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(invoicePreviewUrl)}`;
		const allUsedStockData = await getProcessedStockData(
			customerInvoiceDetails.item_array,
			customerDeliveryChallanList,
			salesReturnDetails
		);
		console.log("salesReturnDetails", salesReturnDetails);
		const stockMap = {};
		allUsedStockData.forEach(s => {
			stockMap[s.item_id] = s;
		});
		const inv = customerInvoiceDetails;
		const branch = branchList.find(b => b.branch_id == inv.branch_id);

		//console.log(image)
		/* ---------------- HEADER DATA ---------------- */
		const qrCode =
			inv.e_invoice_doc?.[0]?.e_invoice_qr_code
				? `${process.env.REACT_APP_GENERAL_IMAGE_BUCKET}/e_invoice_qr_images/${inv.organization_id}/${inv.e_invoice_doc[0].e_invoice_qr_code}`
				: invoicePreviewQr;

		const companyLeftTd = `
        <td style="width:${qrCode ? "80%" : "100%"}; vertical-align:top; padding:6px 0;">
        <div style="max-width:460px; margin:0 auto;">

            <div style="text-align:center; line-height:0; margin-bottom:6px;">
            {{company_logo}}
            </div>

            <div style="font-size:11px; line-height:1.4; text-align:center;">
            REG OFFICE : {{company_address}}
            </div>

            <div style="font-size:11px; text-align:center; margin-bottom:6px;">
            Phone : {{company_phone}} &nbsp;&nbsp; Email : {{company_email}}
            </div>

            <table style="width:100%; border-collapse:collapse; font-size:11px; margin-top:4px;">
            <tr>
                <td style="width:50%; border:0; text-align:left;">
                <strong>From :</strong> {{company_name}}
                </td>
                <td style="width:50%; border:0; text-align:right;">
                <strong>GSTIN :</strong> {{company_gstin}}
                </td>
            </tr>
            </table>

        </div>
        </td>
        `;

		const qrTd = qrCode
			? `
        <td style="width:20%; vertical-align:middle; padding-right:12px;">
        <div
            style="
            width:100%;
            height:100%;
            min-height:100px;
            display:flex;
            align-items:center;
            justify-content:center;
            "
        >
            <img
            src="${qrCode}"
            alt="QR Code"
            style="width:90px; height:90px;"
            />
        </div>
        </td>
        `
			: "";

		const gstin = customerInvoiceDetails.gstin_details?.GstIn;
		const legalName = customerInvoiceDetails.gstin_details?.legal_name;

		const customerGstinBlock = gstin
			? `
    <div style="
      text-align:center;
      font-size:11px;
      font-weight:600;
      margin-top:4px;
      margin-bottom:2px;
    ">
      ${legalName ? legalName + " | " : ""}GSTIN : ${gstin}
    </div>
  `
			: "";   // Hide completely if GSTIN not present



		const replacements = {
			"{{company_left_td}}": companyLeftTd,
			"{{qr_td}}": qrTd,
			"{{company_logo}}": image
				? `
            <div
            style="
                width:100%;
                height:90px;
                display:flex;
                align-items:center;
                justify-content:center;
                overflow:hidden;
            "
            >
            <img
                src="${image}"
                alt="Company Logo"
                style="
                height:100%;
                width:auto;
                transform-origin:center;
                "
            />
            </div>
            `
				: "",

			"{{customer_gstin_block}}": customerGstinBlock,

			"{{company_name}}": organization_name,
			"{{company_address}}": `${branch.branch_address_street1}, ${branch.branch_address_city}, ${branch.branch_address_state} - ${branch.branch_address_zipcode}`,
			"{{company_phone}}": contact_details.phone || "NA",
			"{{company_email}}": contact_details.email || "NA",
			"{{company_gstin}}": branch.GstIn,

			"{{qr_code}}":
				inv.e_invoice_doc?.[0]?.e_invoice_qr_code
					? `${process.env.REACT_APP_GENERAL_IMAGE_BUCKET}/e_invoice_qr_images/${inv.organization_id}/${inv.e_invoice_doc[0].e_invoice_qr_code}`
					: "",

			"{{invoice_no}}": inv.customer_invoice_number || "NA",
			"{{invoice_date}}": moment(inv.invoice_date).format("ll"),

			"{{way_bill_no}}":
				inv.e_way_bill_doc?.[0]?.eway_bill_no ||
				inv.e_invoice_doc?.[0]?.e_invoice_data?.EwbNo ||
				"NA",

			"{{transport_mode}}": inv.transportation_mode || "NA",
			"{{due_date}}": moment(inv.due_date).format("ll"),
			//"{{vehicle_no}}": inv.vehicle_number || "NA",
			"{{payment_terms}}": inv.term || "NA",
			"{{supply_date}}": moment(inv.supplyDate).format("DD-MM-YYYY"),
			"{{place_of_supply}}": inv.place_of_supply || "NA",

		};

		const b = inv.billing_address || {};

		const billingBlock = `
            <div><b>Name</b> : ${inv.customer_name || "NA"}</div>
            <div><b>Address</b> : ${[
				b.address_line1,
				b.address_line2,
				b.city,
				b.state,
				b.pincode
			].filter(Boolean).join(", ")}</div>
            <div>
                <b>Contact</b> : ${[
				b.phone || customerInvoiceDetails.customer_workphone,
				customerInvoiceDetails.mobile
			]
				.filter(Boolean)
				.join(' / ')
			}
            </div>
            <div>
                <b>State</b> : ${(b.state || "").toUpperCase()}
                &nbsp;&nbsp;&nbsp;
            </div>
            `;

		const s = inv.shipping_address || {};

		const shippingBlock = `
            <div><b>Name</b> : ${inv.customer_name || "NA"}</div>
            <div><b>Address</b> : ${[
				s.address_line1,
				s.address_line2,
				s.city,
				s.state,
				s.pincode
			].filter(Boolean).join(", ")}</div>
            <div>
                <b>Contact</b> : ${[
				b.phone || customerInvoiceDetails.customer_workphone,
				customerInvoiceDetails.mobile
			]
				.filter(Boolean)
				.join(' / ')
			}
            </div>
            <div>
                <b>State</b> : ${(s.state || "").toUpperCase()}
                &nbsp;&nbsp;&nbsp;
            </div>
            `;


		const additional = inv.additional_attributes || {};
		const invoiceType = additional.invoice_type || "normal";

		let bankDetails = null;

		if (invoiceType === "wholesale" || printPdfTemplate.includes("{{bank_details_section}}")) {
			bankDetails = await getDefaultBankDetails();
		}


		let extraMetaHtml = "";

		if (additional && invoiceType === "normal") {
			extraMetaHtml = `
            ${additional.loan_id
					? `<div><strong>Loan ID:</strong> ${additional.loan_id}</div>`
					: ""}

            ${additional.dp_amount
					? `<div><strong>DP Amount:</strong> ${additional.dp_amount}</div>`
					: ""}

            ${additional.emi_details
					? `<div><strong>EMI Details:</strong> ${additional.emi_details}</div>`
					: ""}

            ${additional.first_emi_date
					? `<div><strong>First EMI Date:</strong> ${moment(additional.first_emi_date).format("ll")}</div>`
					: ""}
            `;
		}


		if (additional && invoiceType === "wholesale") {
			extraMetaHtml = `
                <div><strong>Car Number:</strong> ${additional.car_number || "NA"}</div>
            `;
		}


		let bankQrRowHtml = "";

		if (additional && invoiceType === "wholesale") {
			bankQrRowHtml = `
                <table>
                <tr>
                    <td style="width:65%; vertical-align:top;">
                    <span class="bold">Bank Details:</span><br>
                    ${bankDetails.bank_name || "NA"}<br>
                    A/C Name: ${bankDetails.account_name || "NA"}<br>
                    A/C No: ${bankDetails.account_number || "NA"}<br>
                    IFSC: ${bankDetails.ifsc || "NA"}
                    </td>

                    <td style="width:35%; vertical-align:top; text-align:center;">
                    ${bankDetails.upi_details &&
					(bankDetails.upi_details.upi_qr_code || bankDetails.upi_details.upi_id)
					? `
                    ${bankDetails.upi_details.upi_qr_code
						? `<img src="${bankDetails.upi_details.upi_qr_code}" style="width:120px;" /><br>`
						: ""
					}

                    ${bankDetails.upi_details.upi_id
						? `<span style="font-size:10px;"><b>UPI ID:</b> ${bankDetails.upi_details.upi_id}</span><br>`
						: ""
					}

                    <span style="font-size:10px;">Scan the QR code to Pay</span>
          `
					: ""
				}
    </td>
                </tr>
                </table>
            `;
		}

		replacements["{{bank_qr_row}}"] = bankQrRowHtml || "";


		// if (additional && invoiceType === "wholesale") {

		// }

		replacements["{{billing_block}}"] = billingBlock;
		replacements["{{shipping_block}}"] = shippingBlock;

		replacements["{{extra_meta}}"] = extraMetaHtml || "";
		replacements["{{bank_qr_row}}"] = bankQrRowHtml || "";


		/* ---------------- ITEMS ---------------- */

		// ==========================================
		// 1. INITIALIZE ACCUMULATORS BEFORE THE LOOP
		// ==========================================
		let totalQty = 0;
		let totalTaxable = 0;
		let grandTotal = 0;
		const globalTaxTotals = {}; // Dynamic storage for CGST, SGST, IGST totals

		const standardTaxTypes = ["CGST", "SGST", "IGST", "UTGST"];
		const activeTaxTypes = new Set();

		// Scan items to find out exactly which taxes are applied in this invoice
		inv.item_array.forEach(item => {
			item.tax_group_details?.forEach(t => {
				if (standardTaxTypes.includes(t.tax_type)) {
					activeTaxTypes.add(t.tax_type);
				}
			});
		});

		// Convert to an array and sort so column ordering remains consistent (e.g., CGST then SGST)
		const dynamicTaxColumns = Array.from(activeTaxTypes).sort();

		// ==========================================
		// 2. GENERATE ITEM ROWS DYNAMICALLY
		// ==========================================
		const itemRowsHtml = inv.item_array.map((item, i) => {
			// Basic quantity and rate fallbacks
			const qty = item.quantity || 0;
			const rate = item.rate || 0;
			const taxable = qty * rate; // Replace with your exact taxable formula if different

			totalQty += qty;
			totalTaxable += taxable;

			// Calculate dynamic taxes for this row and accumulate totals
			const rowTaxAmounts = {};
			dynamicTaxColumns.forEach(taxType => {
				const taxMatch = item.tax_group_details?.find(t => t.tax_type === taxType);
				const taxAmt = taxMatch ? (taxable * taxMatch.tax_percentage) / 100 : 0;

				rowTaxAmounts[taxType] = taxAmt;

				// Accumulate into global totals object
				if (!globalTaxTotals[taxType]) globalTaxTotals[taxType] = 0;
				globalTaxTotals[taxType] += taxAmt;
			});

			// Calculate complete line total for the row
			const totalRowTax = Object.values(rowTaxAmounts).reduce((sum, amt) => sum + amt, 0);
			const lineTotal = taxable + totalRowTax;
			grandTotal += lineTotal;

			// Serial & Batch HTML generation
			const stock = stockMap[item.item_id] || {};
			const serialList = stock.serial_list || [];
			const batchList = stock.batch_list || [];

			const serialHtml = serialList.length
				? `<div style="font-size:10px; margin-top:4px;">
            <b>Serial Nos:</b><br>
            ${serialList.map(s => s.serial_name).join(", ")}
           </div>`
				: "";

			const batchHtml = batchList.length
				? `<div style="font-size:10px; margin-top:4px;">
            <b>Batch:</b>
            ${batchList.map(b => `${b.batch_no} (${b.qty})`).join(", ")}
           </div>`
				: "";

			// Generate dynamic tax <td> elements for this row
			const taxCellsHtml = dynamicTaxColumns.map(taxType => `
        <td class="center small-text">${formatNumber(rowTaxAmounts[taxType], { ...formatNumberOptions, currencyFormat: invoiceCurrencyDetails.format, decimalPlaces: invoiceCurrencyDetails.decimal_place })}</td>
    `).join("");

			return `
        <tr>
            <td class="center">${i + 1}</td>
            <td>
                ${item.item_name}
                ${serialHtml}
                ${batchHtml}
            </td>
            <td class="center small-text">${item.tax_code || ''}</td>
            <td class="center">${qty}</td>
            <td class="center small-text">${formatNumber(rate, { ...formatNumberOptions, currencyFormat: invoiceCurrencyDetails.format, decimalPlaces: invoiceCurrencyDetails.decimal_place })}</td>
            <td class="center small-text">${formatNumber(taxable, { ...formatNumberOptions, currencyFormat: invoiceCurrencyDetails.format, decimalPlaces: invoiceCurrencyDetails.decimal_place })}</td>
            ${taxCellsHtml}
            <td class="center small-text">${formatNumber(lineTotal, { ...formatNumberOptions, currencyFormat: invoiceCurrencyDetails.format, decimalPlaces: invoiceCurrencyDetails.decimal_place })}</td>
        </tr>
    `;
		}).join("");

		// ==========================================
		// 3. BUILD DYNAMIC HEADERS & FOOTERS
		// ==========================================

		// Create dynamic <th> headers based on active taxes
		const taxHeadersHtml = dynamicTaxColumns.map(taxType => `
    <th style="width:8%">${taxType}</th>
`).join("");

		// Calculate layout width dynamically for perfect colspans
		const baseColumnsCount = 6; // #, Description, HSN, Qty, Rate, Taxable
		const totalColumnsInTable = baseColumnsCount + dynamicTaxColumns.length + 1; // +1 for final Amount column

		// Single Row Layout: Shows Quantities Total and Grand Total side-by-side
		let footerRowsHtml = `
    <tr class="bold" style="background-color: #f9f9f9;">
        <td colspan="3" class="right">Total</td>
        <td class="center">${totalQty}</td>
        <td colspan="${totalColumnsInTable - 5}" class="right">Grand Total</td> 
        <td class="right" colspan="1">${invoiceCurrencyDetails.currency_symbol} ${formatNumber(grandTotal, { ...formatNumberOptions, currencyFormat: invoiceCurrencyDetails.format, decimalPlaces: invoiceCurrencyDetails.decimal_place })}</td>
    </tr>
`;

		// ==========================================
		// 4. ASSEMBLE FINAL TABLE HTML
		// ==========================================
		const itemsSectionHtml = `
    <table>
        <tr class="center bold">
            <th style="width:4%">#</th>
            <th style="width:28%">Description</th>
            <th style="width:8%">HSN</th>
            <th style="width:6%">Qty</th>
            <th style="width:8%">Rate</th>
            <th style="width:10%">Taxable</th>
            ${taxHeadersHtml}
            <th style="width:10%">Amount</th>
        </tr>

        ${itemRowsHtml}
        ${footerRowsHtml}
    </table>
`;

		/* ---------------- TOTALS ---------------- */

		replacements["{{items_section}}"] = itemsSectionHtml;


		const tw = new ToWords();
		const amountForWords = Math.round(grandTotal);

		replacements["{{amount_in_words}}"] =
			tw.convert(amountForWords) + " Only";

		/* ---------------- CUSTOMER NOTE + TERMS ---------------- */

		let customerNoteSectionHtml = "";
		let termsConditionsSectionHtml = "";

		// Assuming these fields exist in invoice object
		const customerNote = inv.customer_notes;
		const termsConditions = inv.terms_and_conditions;

		// 👉 Customer Note
		if (customerNote && customerNote.trim() !== "") {
			customerNoteSectionHtml = `
            <table style="width:100%; border-collapse:collapse; font-size:11px; margin-top:8px;">
                <tr>
                    <td style="border:1px solid #000; padding:6px;">
                        <strong>Customer Note:</strong><br>
                        ${customerNote}
                    </td>
                </tr>
            </table>
            `;
		}

		// 👉 Terms & Conditions
		if (termsConditions && termsConditions.trim() !== "") {
			termsConditionsSectionHtml = `
            <table style="width:100%; border-collapse:collapse; font-size:10px; margin-top:8px;">
                <tr>
                    <td style="border:1px solid #000; padding:6px;">
                        <strong>Terms & Conditions:</strong><br>
                        ${termsConditions}
                    </td>
                </tr>
            </table>
            `;
		}

		// Replace placeholders (empty string if not present)
		replacements["{{customer_note_section}}"] = customerNoteSectionHtml;
		replacements["{{terms_conditions_section}}"] = termsConditionsSectionHtml;

		/* ---------------- GST TAX INVOICE PLACEHOLDERS ---------------- */

		Object.assign(replacements, buildGstInvoiceReplacements(inv, branch, stockMap, bankDetails));

		/* ---------------- FINAL HTML ---------------- */

		let finalHtml = printPdfTemplate;

		Object.entries(replacements).forEach(([key, value]) => {
			finalHtml = finalHtml.replaceAll(key, value);
		});

		finalHtml = applyFullPageLayout(finalHtml);

		if (operationType === "print") {
			// Prepare CUSTOMER COPY HTML only
			const customerCopyHtml = finalHtml.replaceAll(
				"{{copy_label}}",
				"Customer Copy"
			);

			// ✅ Save only Customer Copy
			await saveCustomerInvoiceHtmlDetails(customerCopyHtml, html_uid);
			setMainSubmitButtonState(false);
			// Now generate all copies for print
			let copiesHtml = "";

			for (let i = 0; i < noOfCopies; i++) {
				const copyLabel =
					i === 0 ? "Customer Copy" :
						i === 1 ? "Office Copy" :
							`Copy ${i + 1}`;

				let copyHtml = finalHtml.replaceAll(
					"{{copy_label}}",
					copyLabel
				);

				copiesHtml += copyHtml;

				if (i !== noOfCopies - 1) {
					copiesHtml += `<div style="page-break-after:always;"></div>`;
				}
			}


			const w = window.open();
			w.document.write(copiesHtml);
			w.document.close();

			await waitForImages(w);

			w.focus();
			w.print();

		}

		if (operationType === "download") {
			setMainSubmitButtonState(false);
			return finalHtml.replaceAll("{{copy_label}}", "Customer Copy");
		}
	};

	// Stretches templates that follow the full page contract to fill the whole A4 page
	// when the invoice has few items:
	//   .invoice-page  -> page container
	//   .fill-space    -> section that absorbs the remaining height
	//   .fill-grow     -> element inside .fill-space that grows (e.g. empty filler rows of items table)
	// Templates without .invoice-page are returned unchanged.
	const applyFullPageLayout = (html) => {
		if (!html.includes("invoice-page")) return html;

		const fullPageStyle = `
    <style id="full-page-layout">
        @page { size: A4; margin: 8mm; }
        .invoice-page { display: flex; flex-direction: column; }
        .invoice-page .fill-space { flex: 1 1 auto; display: flex; flex-direction: column; }
        .invoice-page .fill-space > .fill-grow { flex: 1 1 auto; }
        @media print {
            html, body { margin: 0; }
            .invoice-page { min-height: 279mm; }
        }
    </style>`;

		return html.includes("</head>") ? html.replace("</head>", `${fullPageStyle}</head>`) : fullPageStyle + html;
	};

	// Placeholders used by GST tax invoice templates (item wise GST, HSN tax summary, payments, bank, acknowledgement)
	const buildGstInvoiceReplacements = (inv, branch, stockMap, bankDetails) => {
		const numberOptions = { currencyFormat: invoiceCurrencyDetails.format, decimalPlaces: invoiceCurrencyDetails.decimal_place, removeTrailingZeros: false };
		const fmt = (value) => formatNumber(value || 0, numberOptions);
		const money = (value) => `${invoiceCurrencyDetails.currency_symbol} ${fmt(value)}`;

		let totalQty = 0;
		let totalTax = 0;
		let itemsTotal = 0;
		const hsnSummary = {};
		const taxTypes = new Set();

		const itemsRows = inv.item_array.map((item, i) => {
			const qty = Number(item.quantity || 0);
			const rate = Number(item.rate || 0);
			const gross = qty * rate;
			const discount = item.discount_type === "amount" ? Number(item.discount_unit || 0) : gross * Number(item.discount_unit || 0) / 100;
			const taxableAmount = gross - discount;

			const taxes = item.taxable == 0 ? [] :
				(item.tax_group_details && item.tax_group_details.length > 0)
					? item.tax_group_details.map(t => ({ type: t.tax_type, rate: Number(t.tax_percentage || 0) }))
					: [{ type: "GST", rate: Number(item.tax_group_percentage || 0) }];
			const taxRate = taxes.reduce((sum, t) => sum + t.rate, 0);
			const taxAmount = taxes.reduce((sum, t) => sum + taxableAmount * t.rate / 100, 0);
			const lineTotal = taxableAmount + taxAmount;

			totalQty += qty;
			totalTax += taxAmount;
			itemsTotal += lineTotal;

			// HSN wise tax summary
			const hsnKey = `${item.tax_code || "-"}|${taxRate}`;
			if (!hsnSummary[hsnKey]) hsnSummary[hsnKey] = { hsn: item.tax_code || "-", taxable: 0, taxes: {} };
			hsnSummary[hsnKey].taxable += taxableAmount;
			taxes.forEach(t => {
				taxTypes.add(t.type);
				if (!hsnSummary[hsnKey].taxes[t.type]) hsnSummary[hsnKey].taxes[t.type] = { rate: t.rate, amount: 0 };
				hsnSummary[hsnKey].taxes[t.type].amount += taxableAmount * t.rate / 100;
			});

			const stock = stockMap[item.item_id] || {};
			const serials = (stock.serial_list || []).map(s => s.serial_name).filter(Boolean);
			const batches = (stock.batch_list || []).map(b => `${b.batch_no} (${b.qty})`);

			return `
            <tr>
                <td>${i + 1}</td>
                <td>
                    <b>${item.item_name}</b>
                    ${serials.length ? `<div class="small">Serial No: ${serials.join(", ")}</div>` : ""}
                    ${batches.length ? `<div class="small">Batch: ${batches.join(", ")}</div>` : ""}
                </td>
                <td>${item.item_code || item.sku || ""}</td>
                <td>${item.tax_code || ""}</td>
                <td class="right">${qty}</td>
                <td class="right">${money(rate)}</td>
                <td class="right">${money(taxAmount)}<br><span class="small">(${taxRate}%)</span></td>
                <td class="right">${money(lineTotal)}</td>
            </tr>`;
		}).join("");

		// tax summary table: HSN | Taxable | <rate, amount per tax type> | Total Tax
		const taxTypeList = Array.from(taxTypes).sort();
		const summaryRows = Object.values(hsnSummary);
		const summaryTaxTotal = (row) => taxTypeList.reduce((sum, type) => sum + (row.taxes[type] ? row.taxes[type].amount : 0), 0);
		const taxSummarySection = `
            <table class="inner">
                <tr>
                    <th rowspan="2" class="center">HSN/ SAC</th>
                    <th rowspan="2" class="center">Taxable amount (${invoiceCurrencyDetails.currency_symbol})</th>
                    ${taxTypeList.map(type => `<th colspan="2" class="center">${type}</th>`).join("")}
                    <th rowspan="2" class="center">Total Tax (${invoiceCurrencyDetails.currency_symbol})</th>
                </tr>
                <tr>
                    ${taxTypeList.map(() => `<th class="center">Rate (%)</th><th class="center">Amt (${invoiceCurrencyDetails.currency_symbol})</th>`).join("")}
                </tr>
                ${summaryRows.map(row => `
                <tr>
                    <td>${row.hsn}</td>
                    <td class="right">${fmt(row.taxable)}</td>
                    ${taxTypeList.map(type => row.taxes[type]
				? `<td class="right">${row.taxes[type].rate}</td><td class="right">${fmt(row.taxes[type].amount)}</td>`
				: `<td class="right">-</td><td class="right">-</td>`).join("")}
                    <td class="right">${fmt(summaryTaxTotal(row))}</td>
                </tr>`).join("")}
                <tr class="bold">
                    <td class="right">TOTAL</td>
                    <td class="right">${fmt(summaryRows.reduce((sum, row) => sum + row.taxable, 0))}</td>
                    ${taxTypeList.map(type => `<td></td><td class="right">${fmt(summaryRows.reduce((sum, row) => sum + (row.taxes[type] ? row.taxes[type].amount : 0), 0))}</td>`).join("")}
                    <td class="right">${fmt(totalTax)}</td>
                </tr>
            </table>`;

		const grandTotal = Number(inv.grand_total || itemsTotal);
		const received = customerInvoicePaymentDetails
			.filter(p => p.log_status === "Paid")
			.reduce((sum, p) => sum + Number(p.payment_amount || 0), 0);

		const b = inv.billing_address || {};
		const customerContact = [b.phone || inv.customer_workphone, inv.mobile].filter(Boolean).join(" / ") || "NA";
		const gstin = inv.gstin_details?.GstIn;
		const additional = inv.additional_attributes || {};

		// invoice type specific details shown next to invoice details ("Label: <b>value</b>")
		const metaDetails = (additional.invoice_type || "normal") === "wholesale"
			? [["Car Number", additional.car_number]]
			: [
				["Loan ID", additional.loan_id],
				["D.P", additional.dp_amount],
				["EMI", additional.emi_details],
				["EMI Start Date", additional.first_emi_date ? moment(additional.first_emi_date).format("DD/MM/YYYY") : ""],
			];
		const invoiceMetaDetails = metaDetails
			.filter(([, value]) => value)
			.map(([label, value]) => `<div>${label}:&nbsp; <b>${value}</b></div>`)
			.join("");

		return {
			"{{company_logo_img}}": image ? `<img src="${image}" class="org-logo" alt="Logo" />` : "",
			"{{company_state}}": branch?.branch_address_state || "NA",
			"{{customer_name}}": inv.customer_name || "NA",
			"{{billing_address_text}}": [b.address_line1, b.address_line2, b.city, b.state, b.pincode].filter(Boolean).join(", ") || "NA",
			"{{customer_contact}}": customerContact,
			"{{customer_gstin_line}}": gstin ? `<div>GSTIN: <b>${gstin}</b></div>` : "",
			"{{invoice_date_dmy}}": moment(inv.invoice_date).format("DD/MM/YYYY"),
			"{{invoice_date_dash}}": moment(inv.invoice_date).format("DD-MM-YYYY"),
			"{{invoice_meta_details}}": invoiceMetaDetails,
			"{{items_rows}}": itemsRows,
			"{{total_qty}}": totalQty,
			"{{total_tax_amount}}": money(totalTax),
			"{{items_total_amount}}": money(itemsTotal),
			"{{sub_total}}": money(itemsTotal),
			"{{grand_total_amount}}": money(grandTotal),
			"{{tax_summary_section}}": taxSummarySection,
			"{{received_amount}}": money(received),
			"{{balance_amount}}": money(Math.max(grandTotal - received, 0)),
			"{{payment_mode}}": additional.payment_mode || "NA",
			"{{bank_details_section}}": bankDetails
				? `Name : <b>${bankDetails.bank_name || "NA"}</b><br>
                   Account No. : <b>${bankDetails.account_number || "NA"}</b><br>
                   IFSC code : <b>${bankDetails.ifsc || "NA"}</b><br>
                   Account holder's name : <b>${bankDetails.account_name || "NA"}</b>`
				: "NA",
		};
	};

	const handleInvoiceStatusModalClose = () => {
		setInvoiceStatusModalShow(false);
		setInvoiceStatus(null);
	}

	const handleOperationBill = (operation) => {
		let tbr = branchList.find(x => x.branch_id === customerInvoiceDetails.branch_id)
		let gst = customerInvoiceDetails.gstin_details

		let organization_details =
			`<div class="card-body p-2">
				<div class="text-end">
					<span class="fw-semi-bold fs-7">SALES INVOICE</span>
				</div>
				${image ? `
			<div>
				<img src="${image}" alt="Organization Logo" class="rounded float-left" style="height: 100px; object-fit: contain;">
				<div class="fw-bold"><h2>${organization_name}</h2></div>
			</div>`
				:
				`<div class="fw-bold"><h5>${organization_name}</h5></div>`
			}
			</div>`

		let branch_details =
			`<div class="card-body p-2">
				<div class="row mb-7">				
					<span class="fw-semibold text-gray-800 fs-6">
						Org GST: ${tbr.GstIn}
					</span>				
				</div>
				<div class="row mb-7">					
					<span class="fw-semibold text-gray-800 fs-6">
						Branch Details: ${tbr.branch_name}-${tbr.branch_address_street1}-${tbr.branch_address_city}-${tbr.branch_address_state}-${tbr.branch_address_zipcode}
					</span>
				</div>
				<div class="row mb-7">	
					<span class="fw-semibold text-gray-800 fs-6">
						Phone: ${tbr.branch_address_phone}
					</span>					
				</div>
				<div class="row mb-7">					
					<span class="fw-semibold text-gray-800 fs-6">
						IRN: NA
					</span>					
				</div>				
				
				<div class="row mb-7">
					<span class="fw-semibold text-gray-800 fs-6">
						Way Bill No: NA &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Way Bill Date: NA
					</span>
				</div>
			</div >`

		let document_details =
			`<div class="card-body p-2">
				<label class="fw-bold text-muted">Invoice Details</label>
				<div class="row mb-7">
					<span class="fw-semibold text-gray-800 fs-6">
						Reference Number: ${customerInvoiceDetails.reference_number ? customerInvoiceDetails.reference_number : "NA"}
					</span>
				</div>
				<div class="row mb-7">
					<span class="fw-semibold text-gray-800 fs-6">
						Order Number: ${customerInvoiceDetails.order_data[0]?.customer_order_number || "NA"}
					</span>
				</div>
				<div class="row mb-7">
					<span class="fw-semibold text-gray-800 fs-6">
						Order Date: ${customerInvoiceDetails.order_data[0]?.order_date ? moment(customerInvoiceDetails.order_data[0].order_date).format('ll') : "NA"}
					</span>
				</div>
				<div class="row mb-7">
					<span class="fw-semibold text-gray-800 fs-6">
						Invocie Number: ${customerInvoiceDetails.customer_invoice_number ? customerInvoiceDetails.customer_invoice_number : "NA"}
					</span>
				</div >
				<div class="row mb-7">
					<span class="fw-semibold text-gray-800 fs-6">
						Invoice Date: ${customerInvoiceDetails.invoice_date ? moment(customerInvoiceDetails.invoice_date).format('ll') : "NA"}
					</span>
				</div >
			</div>`

		let tb = customerInvoiceDetails.billing_address
		let ts = customerInvoiceDetails.shipping_address

		let customer_details =
			`<div class="card-body p-2">
				<label class="fw-bold text-muted">Customer Details</label>				
				<div class="row mb-7">
					<span class="fw-semibold text-gray-800 fs-6">
						Name: ${customerInvoiceDetails.customer_name}
					</span>
				</div>
				<div class="row mb-7">
					<span class="fw-semibold text-gray-800 fs-6">
						Phone: ${customerInvoiceDetails.customer_workphone ? customerInvoiceDetails.customer_workphone : "NA"}
					</span>
				</div>
				<div class="row mb-7">
					<span class="fw-semibold text-gray-800 fs-6">
						email: ${customerInvoiceDetails.customer_email ? customerInvoiceDetails.customer_email : "NA"}
					</span>
				</div>
				<div class="row mb-7">
					<span class="fw-semibold text-gray-800 fs-6">
						GST: ${gst.GstIn === "" ? "NA" : gst.GstIn}
					</span>
				</div>
				<div class="row mb-7">
					<span class="fw-semibold text-gray-800 fs-6">
						PAN: NA
					</span>
				</div>
				<div class="row mb-7">
					<span class="fw-semibold text-gray-800 fs-6">
						Reciever Address (Billing): ${tb.address_line1 == "" ? "" : tb.address_line1 + ", "}${tb.address_line2 == "" ? "" : tb.address_line2 + ", "}${tb.city == "" ? "" : tb.city + ", "}${tb.state == "" ? "" : tb.state + ", "}${tb.country == "" ? "" : tb.country + ", "}${tb.pincode}
					</span>
				</div>
				<div class="d-flex">
					<span class="fw-semibold text-gray-800 fs-6">
						Consignee Address (Shipping): ${ts.address_line1 == "" ? "" : ts.address_line1 + ", "}${ts.address_line2 == "" ? "" : ts.address_line2 + ", "}${ts.city == "" ? "" : ts.city + ", "}${ts.state == "" ? "" : ts.state + ", "}${ts.country == "" ? "" : ts.country + ", "}${tb.pincode}
					</span>
				</div>
				<div class="d-flex">
					<span class="fw-semibold text-gray-800 fs-6">
						Due Date: ${moment(customerInvoiceDetails.due_date).format('ll')}
					</span>
				</div>				
			</div>`

		let table_details =

			`<table class="text-center table table-bordered">
				<thead>
					<tr>						
						<th rowspan="2">Item Name</th>						
						<th rowspan="2">Qty</th>												
						<th rowspan="2">Amt</th>
						<th rowspan="2">Tax</th>
					</tr>						
				</thead>
				<tbody>
					##
					<tr>						
						<td>{{description_of_goods}}</td>						
						<td>{{quantity}}</td>												
						<td>{{amount}}</td>
						<td>{{taxable_percentage}}</td>
					</tr>
					##
				<tbody>	
				<tfoot>
					<tr>							
						<td colspan="3">SubTotal</td>
						<td>{{subtotal}}</td>
					</tr>
					{{tax_total_details}}
					{{tds_tcs_details}}
					<tr>
						<td colspan="3">{{adjustment_text}}</td>
						<td>{{adjustment_value}}</td>
					</tr>
					<tr>
						<td colspan="3">Order Grand Total</td>
						<td colspan="3">{{document_total}}</td>
					</tr>
					<tr>
					<td colspan="4" style="text-align: left;">
						Total Items: 2<br>
						Total in Words: <br> Fifty Four Thousand Eight Hundred Point Zero Two Only <br><br>
						Customer Note: <br>  <br><br>
						Terms and Conditions: <br>  <br><br>
					</td>
					</tr>
				</tfoot>						
			</table>`

		let td = taxDetails.reduce((p, o) => {
			if (p.hasOwnProperty(o.tax_type)) {
				p[o.tax_type] += o.tax_amount
			}
			else {
				p[o.tax_type] = o.tax_amount
			}
			return p
		}, {})

		let tax_column_count = 1
		let tch1 = ""
		let tch2 = ""
		if (td.hasOwnProperty("CGST")) {
			tch1 += `<th colspan="2">CGST</th>`
			tch2 += `<th>%</th>
			<th>Amt.</th>`
			tax_column_count += 2
		}
		if (td.hasOwnProperty("SGST")) {
			tch1 += `<th colspan="2">SGST</th>`
			tch2 += `<th>%</th>
			<th>Amt.</th>`
			tax_column_count += 2
		}
		if (td.hasOwnProperty("UTGST")) {
			tch1 += `<th colspan="2">UTGST</th>`
			tch2 += `<th>%</th>
			<th>Amt.</th>`
			tax_column_count += 2
		}
		if (td.hasOwnProperty("IGST")) {
			tch1 += `<th colspan="2">IGST</th>`
			tch2 += `<th>%</th>
			<th>Amt.</th>`
			tax_column_count += 2
		}

		let footer_row_count = 2
		let fd1 = ""
		if (td.hasOwnProperty("CGST")) {
			fd1 += `<tr>
				<td colspan="${tax_column_count}">CGST Total</td>
				<td>${td["CGST"]}</td>
			</tr>`
			footer_row_count++
		}
		if (td.hasOwnProperty("SGST")) {
			fd1 += `<tr>
				<td colspan="${tax_column_count}">SGST Total</td>
				<td>${td["SGST"]}</td>
			</tr>`
			footer_row_count++
		}
		if (td.hasOwnProperty("UTGST")) {
			fd1 += `<tr>
				<td colspan="${tax_column_count}">UTGST Total</td>
				<td>${td["UTGST"]}</td>
			</tr>`
			footer_row_count++
		}
		if (td.hasOwnProperty("IGST")) {
			fd1 += `<tr>
				<td colspan="${tax_column_count}">IGST Total</td>
				<td>${td["IGST"]}</td>
			</tr>`
			footer_row_count++
		}

		let fd2 = ""
		if (customerInvoiceDetails.tax_category != null) {
			fd2 = `<tr>
				<td colspan="${tax_column_count}">TDS/TCS Total</td>
				<td>${Math.round((customerInvoiceDetails.tax_category == "TDS" ? customerInvoiceDetails.item_array.reduce((p, o) => { return p + ((o.quantity * o.rate) - (o.discount_type == "amount" ? o.discount_unit : o.quantity * o.rate * o.discount_unit / 100)) }, 0) : subTotal) * (customerInvoiceDetails.tax_id == null ? 0 : parseFloat(customerInvoiceDetails.tax_percentage)) / 100 * decimalPlace) / decimalPlace}</td>
			</tr>`
			footer_row_count++
		}

		let cd = customerInvoiceDetails.invoice_currency

		let decimalPlace = cd.decimal_place;

		function round(value, decimals) {
			return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
		}

		let roundedSubTotal = round(subTotal, decimalPlace);

		table_details = table_details.replace("{{subtotal}}", roundedSubTotal)

		let roundedFd1 = Object.entries(td).map(([taxType, amount]) => {
			return `<tr>
				<td colspan="${tax_column_count}">${taxType} Total</td>
				<td>${round(amount, decimalPlace)}</td>
			</tr>`
		}).join('');

		let roundedFd2 = `<tr>
			  <td colspan="${tax_column_count}">TDS/TCS Total</td>
			  <td>${round(Math.round((customerInvoiceDetails.tax_category == "TDS" ? customerInvoiceDetails.item_array.reduce((p, o) => { return p + ((o.quantity * o.rate) - (o.discount_type == "amount" ? o.discount_unit : o.quantity * o.rate * o.discount_unit / 100)) }, 0) : subTotal) * (customerInvoiceDetails.tax_id == null ? 0 : parseFloat(customerInvoiceDetails.tax_percentage)) / 100 * decimalPlace) / decimalPlace, decimalPlace)}</td>
		  </tr>`

		table_details = table_details.replace("{{footer_row_count}}", footer_row_count)
		table_details = table_details.replace("{{tax_total_details}}", roundedFd1);
		table_details = table_details.replace("{{tds_tcs_details}}", roundedFd2);

		table_details = table_details.replace("{{adjustment_text}}", customerInvoiceDetails.adjustment.text)
		table_details = table_details.replace("{{adjustment_value}}", customerInvoiceDetails.adjustment.value)

		let d = customerInvoiceDetails.item_array
		let tw = new ToWords()

		table_details = table_details.replace("{{total_items}}", d.length)
		table_details = table_details.replace("{{total_in_words}}", tw.convert(customerInvoiceDetails.grand_total) + " Only")
		table_details = table_details.replace("{{customer_note}}", customerInvoiceDetails.customer_notes)
		table_details = table_details.replace("{{terms_and_conditions}}", customerInvoiceDetails.terms_and_conditions)

		let rs = table_details.indexOf("##")
		let re = table_details.lastIndexOf("##")
		let r_code = table_details.substring(rs + 2, re)

		let item = customerInvoiceDetails.item_array.map((obj, i) => {

			let temp = r_code
			temp = temp.replace("{{description_of_goods}}", obj.item_name)
			temp = temp.replace("{{quantity}}", obj.quantity)
			temp = temp.replace("{{amount}}", Math.round((((obj.quantity * obj.rate) - (obj.discount_type == "amount" ? obj.discount_unit : obj.quantity * obj.rate * obj.discount_unit / 100)) + (obj.taxable == 0 ? 0 : ((obj.quantity * obj.rate) - (obj.discount_type == "amount" ? obj.discount_unit : obj.quantity * obj.rate * obj.discount_unit / 100)) * (obj.tax_group_percentage / 100))) * decimalPlace) / decimalPlace)
			temp = temp.replace("{{taxable_percentage}}", obj.tax_group_percentage === null ? 0 : obj.tax_group_percentage)

			let tcd = ""
			if (td.hasOwnProperty("CGST")) {
				let v = obj.taxable == 0 ? undefined : obj.tax_group_details.find(x => x.tax_type == "CGST")
				if (v != undefined) {
					tcd += `<td>${v.tax_percentage}%</td>
					<td>${Math.round((Math.round(((obj.quantity * obj.rate) - (obj.discount_type == "amount" ? obj.discount_unit : obj.quantity * obj.rate * obj.discount_unit / 100)) * decimalPlace) / decimalPlace) * v.tax_percentage / 100 * decimalPlace) / decimalPlace}</td>`
				}
				else {
					tcd += `<td>--</td>
					<td>--</td>`
				}
			}
			if (td.hasOwnProperty("SGST")) {
				let v = obj.taxable == 0 ? undefined : obj.tax_group_details.find(x => x.tax_type == "SGST")
				if (v != undefined) {
					tcd += `<td>${v.tax_percentage}%</td>
					<td>${Math.round((Math.round(((obj.quantity * obj.rate) - (obj.discount_type == "amount" ? obj.discount_unit : obj.quantity * obj.rate * obj.discount_unit / 100)) * decimalPlace) / decimalPlace) * v.tax_percentage / 100 * decimalPlace) / decimalPlace}</td>`
				}
				else {
					tcd += `<td>--</td>
					<td>--</td>`
				}
			}
			if (td.hasOwnProperty("UTGST")) {
				let v = obj.taxable == 0 ? undefined : obj.tax_group_details.find(x => x.tax_type == "UTGST")
				if (v != undefined) {
					tcd += `<td>${v.tax_percentage}%</td>
					<td>${Math.round((Math.round(((obj.quantity * obj.rate) - (obj.discount_type == "amount" ? obj.discount_unit : obj.quantity * obj.rate * obj.discount_unit / 100)) * decimalPlace) / decimalPlace) * v.tax_percentage / 100 * decimalPlace) / decimalPlace}</td>`
				}
				else {
					tcd += `<td>--</td>
					<td>--</td>`
				}
			}
			if (td.hasOwnProperty("IGST")) {
				let v = obj.taxable == 0 ? undefined : obj.tax_group_details.find(x => x.tax_type == "IGST")
				if (v != undefined) {
					tcd += `<td>${v.tax_percentage}%</td>
					<td>${Math.round((Math.round(((obj.quantity * obj.rate) - (obj.discount_type == "amount" ? obj.discount_unit : obj.quantity * obj.rate * obj.discount_unit / 100)) * decimalPlace) / decimalPlace) * v.tax_percentage / 100 * decimalPlace) / decimalPlace}</td>`
				}
				else {
					tcd += `<td>--</td>
					<td>--</td>`
				}
			}

			temp = temp.replace("{{tax_column_details}}", tcd)
			table_details = table_details.replace("{{document_total}}", customerInvoiceDetails.invoice_currency.currency_symbol + " " + customerInvoiceDetails.grand_total)
			return temp
		}).join("")
		table_details = table_details.substring(0, rs) + item + table_details.substring(re + 2, table_details.length);

		let modifiedBillTemplate = printBillTemplate
		modifiedBillTemplate = modifiedBillTemplate.replace("{{organization_details}}", organization_details)
		modifiedBillTemplate = modifiedBillTemplate.replace("{{branch_details}}", branch_details)
		modifiedBillTemplate = modifiedBillTemplate.replace("{{main_details}}", document_details)
		modifiedBillTemplate = modifiedBillTemplate.replace("{{customer_details}}", customer_details)
		modifiedBillTemplate = modifiedBillTemplate.replace("{{item_details}}", table_details)
		// console.log(modifiedTemplate);
		if (operation === 'print') {
			let nnww = window.open()
			nnww.document.body.parentNode.innerHTML = modifiedBillTemplate;

			setTimeout(() => {
				nnww.print();
			}, 1000);
		}
		else if (operation === 'download') {
			return modifiedBillTemplate;
		}
	}

	const generateDownload = async () => {

		setLoading(true);
		const htmlContent = await handleOperation('download');

		let object = {};
		// console.log(organization_name)
		object.organizaiton_name = organization_name
		object.html_code = htmlContent
		object.organization_id = organization_id
		object.page_name = page_name;

		// console.log(object);
		setDownloadModalShow(true)


		var headers = {
			headers: {
				"Content-Type": "application/json",
				"Accept": "*/*",
				"token": getCookie("access_token")
			}
		}

		axios.post(`${process.env.REACT_APP_SERVER_URL}/download-invoice-details-pdf`, object, headers).then((res) => {
			setDownloadModalShow(false)
			if (res.data.operation === "success") {
				swal("File Created!", "Go to File.", "success").then(() => {
					window.open(res.data.data.file_url, "_blank");
					setLoading(false);
				});
			} else {
				swal("Oops!", "Something went wrong!", "error");
			}
		})
			.catch(function (error) {
				console.log(error)
				setLoading(false);
			});
	}

	const processInvoiceToWarehouse = () => {
		var object = {}

		object.customer_invoice_id = props.match.params.id
		object.organization_id = organization_id
		object.page_name = page_name;
		setSubmitButtonState(true)

		var headers = {
			headers: {
				"Content-Type": "application/json",
				"Accept": "*/*",
				"token": getCookie("access_token")
			}
		}
		axios.post(`${process.env.REACT_APP_SERVER_URL}/process-customer-invoice-warehouse`, object, headers).then((res) => {
			setSubmitButtonState(false)
			if (res.data.operation === "success") {
				swal("Great!", `Invoice started for Warehouse Processing!`, "success").then((value) => {
					history.push(`/customer-warehouse-processing-list`)
				})
			}
			else {
				if (res.data.data?.credit_note_id) {
					swal("Oops!", res.data.message, {
						buttons: {
							nothing: { text: "Ok", className: "btn btn-secondary" },
							redirect: { text: "Go to Credit Note", className: "btn btn-info" },
						}
					})
						.then((value) => {
							switch (value) {
								case "redirect": history.push(`/edit-credit-note/${res.data.data.credit_note_id}`); break;
							}
						});
				}

				else {
					swal("Oops!", res.data.message, "error");
				}
			}
		})
			.catch(function (error) {
				console.log(error)
			});
	}

	return (
		<>
			<div>
				<div className="d-flex flex-stack mb-5">
					<div className="page-title d-flex justify-content-center flex-wrap gap-5">
						<h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">View Customer Invoice</h1>
						<Tooltip title="SpotERP Docs" >
							<a
								href={`${process.env.REACT_APP_SPOTERP_DOCS}/sales/invoice/invoice_list#view-customer-invoice`}
								className='btn btn-light-primary py-2 px-3'
								target="_blank"
							>
								<i className="bi bi-journal-text fs-1 px-0"></i>
							</a>
						</Tooltip>
					</div>

					{
						state === 1 &&
						<Navbar collapseOnSelect expand="lg" className="me-5 position-relative">
							<Navbar.Toggle />
							<Navbar.Collapse>
								<Nav className="align-items-end end-0 gap-3 navbar-nav p-5 position-absolute z-index-1">
									{
										approveFinalButtonShow && customerInvoiceDetails.add_status === "CUSTOMER_INVOICE_PENDING_APPROVAL" &&
										<Nav.Item>
											<button className='btn btn-light-success btn-hover-scale btn-sm border border-success' title='Final Approve' data-kt-indicator={submitButtonState ? "on" : "off"} disabled={submitButtonState}
												onClick={() => {
													swal("Alert!", "Are you sure you want to proceed?", {
														buttons: {
															nothing: { text: "Cancel", className: "btn btn-secondary" },
															edit: { text: "Modify", className: "btn btn-warning" },
															approve: { text: "Approve", className: "btn btn-danger" },
														}
													})
														.then((value) => {
															switch (value) {
																case "edit": history.push(`/edit-customer-invoice/${props.match.params.id}`); break;
																case "approve": approveInvoiceSubmit(true, false, ""); break;
															}
														});
												}}
											>
												<span className="indicator-label"><i className="bi bi-shield-check p-0 fs-1"></i></span>
												<span className="indicator-progress">
													<span className="spinner-border spinner-border-sm align-middle h-20px w-20px"></span>
												</span>
											</button>
										</Nav.Item>
									}
									{
										approveButtonShow && customerInvoiceDetails.add_status === "CUSTOMER_INVOICE_PENDING_APPROVAL" &&
										<Nav.Item>
											<button className='btn btn-light-success btn-hover-scale btn-sm border border-success' title='Approve' data-kt-indicator={submitButtonState ? "on" : "off"} disabled={submitButtonState}
												onClick={() => {
													swal("Alert!", "Are you sure you want to proceed?", {
														buttons: {
															nothing: { text: "Cancel", className: "btn btn-secondary" },
															edit: { text: "Modify", className: "btn btn-warning" },
															approve: { text: "Approve", className: "btn btn-danger" },
														}
													})
														.then((value) => {
															switch (value) {
																case "edit": history.push(`/edit-customer-invoice/${props.match.params.id}`); break;
																case "approve": approveInvoiceSubmit(false, false, ""); break;
															}
														});
												}}
											>
												<span className="indicator-label"><i className="bi bi-check-circle p-0 fs-1"></i></span>
												<span className="indicator-progress">
													<span className="spinner-border spinner-border-sm align-middle h-20px w-20px"></span>
												</span>
											</button>
										</Nav.Item>
									}
									{
										cancelButtonShow && customerInvoiceDetails.add_status === "CUSTOMER_INVOICE_PENDING_APPROVAL" &&
										<Nav.Item>
											<button className='btn btn-light-danger btn-hover-scale btn-sm border border-danger' title='Cancel' data-kt-indicator={submitButtonState ? "on" : "off"} disabled={submitButtonState}
												onClick={() => {
													swal({
														title: "Alert!",
														text: "Please type a reason before cancelling",
														icon: "warning",
														content: "input",
														buttons: true,
														dangerMode: true,
													})
														.then((msg) => {
															if (msg === "") {
																swal("Alert!", "Message cannot be empty", "warning")
															} else if (msg) {
																approveInvoiceSubmit(false, true, msg);
															}
														});
												}}
											>
												<span className="indicator-label"><i className="bi bi-x-circle p-0 fs-1"></i></span>
												<span className="indicator-progress">
													<span className="spinner-border spinner-border-sm align-middle h-20px w-20px"></span>
												</span>
											</button>
										</Nav.Item>
									}
									{
										customerInvoiceDetails.add_status === "CUSTOMER_INVOICE_FINALIZED" &&
										<Nav.Item>
											<button className='btn btn-light-success btn-hover-scale btn-sm border border-success py-3' title='process to warehouse' data-kt-indicator={submitButtonState ? "on" : "off"} disabled={submitButtonState} onClick={() => { processInvoiceToWarehouse() }}>
												<span className="indicator-label">
													<svg viewBox="0 0 90 100" width="24" height="24" fill="currentColor">
														<path d="M27.358,53.154V1.331A1.331,1.331,0,0,1,28.689,0H81.563a1.321,1.321,0,0,1,.951.4L94.345,12.231a1.321,1.321,0,0,1,.389.953V85.236A1.331,1.331,0,0,1,93.4,86.567H46.569l1.686,1.687a1.329,1.329,0,0,1,0,1.881l-6.008,6.009a1.332,1.332,0,0,1-1.882,0l-3.7-3.7a17.958,17.958,0,0,1-2.4.994v5.232A1.331,1.331,0,0,1,32.937,100h-8.5a1.331,1.331,0,0,1-1.331-1.331V93.437l-1.217-.455v0q-.6-.247-1.18-.541l-3.7,3.7a1.332,1.332,0,0,1-1.882,0L9.122,90.135a1.329,1.329,0,0,1,0-1.881l3.7-3.7a17.719,17.719,0,0,1-.994-2.4H6.6a1.331,1.331,0,0,1-1.331-1.331v-8.5A1.33,1.33,0,0,1,6.6,71h5.232a17.8,17.8,0,0,1,1-2.4l-3.7-3.7a1.33,1.33,0,0,1,0-1.882L15.13,57.01a1.332,1.332,0,0,1,1.882,0l3.7,3.7a18.1,18.1,0,0,1,2.4-.994V54.485a1.331,1.331,0,0,1,1.331-1.331ZM57.846,67.192H85.2a1.331,1.331,0,0,0,0-2.661H57.846a1.331,1.331,0,0,0,0,2.661ZM45.974,54.435H85.2a1.331,1.331,0,0,0,0-2.662H45.974a1.331,1.331,0,1,0,0,2.662ZM38.553,41.677H85.2a1.331,1.331,0,0,0,0-2.661H38.553a1.331,1.331,0,0,0,0,2.661Zm0-12.757H85.2a1.331,1.331,0,0,0,0-2.662H38.553a1.331,1.331,0,0,0,0,2.662Zm0-12.758H77.084a1.331,1.331,0,1,0,0-2.661H38.553a1.331,1.331,0,0,0,0,2.661ZM28.689,66.314A10.263,10.263,0,1,0,38.952,76.577,10.264,10.264,0,0,0,28.689,66.314ZM34.064,71.2a7.6,7.6,0,1,0,0,10.75,7.6,7.6,0,0,0,0-10.75Zm8.358,14.982-.448-.448,0,0a1.329,1.329,0,0,1-.21-1.6,14.777,14.777,0,0,0,.876-1.775h0a14.977,14.977,0,0,0,.614-1.807,1.332,1.332,0,0,1,1.3-1.054h4.89V73.659H44.56a1.331,1.331,0,0,1-1.284-.987,15.045,15.045,0,0,0-.634-1.873h0a15.517,15.517,0,0,0-.834-1.7,1.331,1.331,0,0,1,.164-1.682l3.459-3.459-4.127-4.126-3.458,3.458,0,0a1.327,1.327,0,0,1-1.6.21,15.271,15.271,0,0,0-3.581-1.492,1.331,1.331,0,0,1-1.055-1.3v-4.89H25.771v4.89h0a1.328,1.328,0,0,1-.986,1.284,15.109,15.109,0,0,0-3.572,1.466,1.331,1.331,0,0,1-1.682-.164l-3.458-3.458-4.127,4.126L15.4,67.418l0,0a1.329,1.329,0,0,1,.21,1.6,14.983,14.983,0,0,0-1.492,3.581,1.332,1.332,0,0,1-1.3,1.054H7.927V79.5h4.89a1.331,1.331,0,0,1,1.284.986,15.244,15.244,0,0,0,1.466,3.572,1.331,1.331,0,0,1-.164,1.682l-3.459,3.458,4.127,4.127,3.458-3.458,0,0a1.327,1.327,0,0,1,1.6-.21,15.238,15.238,0,0,0,1.775.876h0a14.964,14.964,0,0,0,1.806.615,1.33,1.33,0,0,1,1.055,1.3v4.889h5.835V92.449h0a1.328,1.328,0,0,1,.986-1.284A15.1,15.1,0,0,0,36.166,89.7a1.331,1.331,0,0,1,1.682.165l3.458,3.458,4.127-4.127-3.011-3.01Zm2.443-2.279H92.073V14.5H81.563a1.331,1.331,0,0,1-1.331-1.331V2.662H30.019V53.154h2.918a1.331,1.331,0,0,1,1.331,1.331v5.231a17.9,17.9,0,0,1,2.4.994l3.7-3.7a1.332,1.332,0,0,1,1.882,0l6.008,6.008a1.33,1.33,0,0,1,0,1.882l-3.7,3.7c.193.383.373.777.54,1.179h0c.165.4.317.807.453,1.219h5.232a1.33,1.33,0,0,1,1.331,1.33v8.5a1.331,1.331,0,0,1-1.331,1.331H45.548l-.454,1.217h0q-.111.267-.231.531ZM90.191,11.841l-7.3-7.3v7.3Z" />
													</svg>
												</span>
												<span className="indicator-progress">
													<span className="spinner-border spinner-border-sm align-middle h-20px w-20px"></span>
												</span>
											</button>
										</Nav.Item>
									}
									{
										(customerInvoiceDetails.add_status === "CUSTOMER_INVOICE_PENDING_APPROVAL" || customerInvoiceDetails.add_status === "CUSTOMER_INVOICE_DRAFT" || customerInvoiceDetails.add_status === "CUSTOMER_INVOICE_FINALIZED") &&
										<Nav.Item>
											<button className='btn btn-light-warning btn-hover-scale btn-sm border border-warning' title='Edit' data-kt-indicator={submitButtonState ? "on" : "off"} disabled={submitButtonState}
												onClick={() => {
													const warningMessage = customerInvoiceDetails.add_status === "CUSTOMER_INVOICE_FINALIZED"
														? "Are you sure you want to proceed? Editing the details after being finalized will reset the status."
														: "Are you sure you want to proceed?";

													swal("Alert!", warningMessage, {
														buttons: {
															nothing: { text: "Cancel", className: "btn btn-secondary" },
															edit: { text: "Modify", className: "btn btn-warning" }
														}
													})
														.then((value) => {
															switch (value) {
																case "edit": history.push(`/edit-customer-invoice/${props.match.params.id}`); break;
															}
														});
												}}
											>
												<i className="bi bi-pencil-square fs-1 p-0"></i>
											</button>
										</Nav.Item>
									}
									<Nav.Item>
										<button className='btn btn-sm btn-info btn-hover-scale' onClick={() => { setPrintModalShow(true) }}><i className="bi bi-printer fs-2x p-0"></i></button>
									</Nav.Item>
									<Nav.Item>
										<button className='btn btn-sm btn-info btn-hover-scale' onClick={() => { setDownloadModalShow(true) }}><i className="bi bi-file-earmark-arrow-down fs-2x p-0"></i></button>
									</Nav.Item>
									{((customerInvoiceDetails.add_status === "CUSTOMER_INVOICE_FINALIZED" || customerInvoiceDetails.add_status === "CUSTOMER_INVOICE_WAREHOUSE") && customerInvoiceDetails.payment_status == "Paid") &&
										<Nav.Item>
											<button className='btn btn-sm btn-success btn-hover-scale' onClick={() => { setInvoiceStatusModalShow(true); getInvoiceStatus(customerInvoiceDetails.customer_invoice_id); }}>Complete</button>
										</Nav.Item>
									}
								</Nav>
							</Navbar.Collapse>
						</Navbar>
					}
				</div>
				<div>
					{state === 1 ?
						<>
							<div className="d-flex flex-column gap-7 gap-lg-10">
								<div className="d-flex flex-wrap flex-stack gap-5 gap-lg-10">
									<ul className="nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semibold mb-lg-n2 me-auto" role="tablist">
										<li className="nav-item" role="presentation">
											<a className="nav-link text-active-primary pb-4 active" data-bs-toggle="tab" href="#kt_ecommerce_sales_invoice_summary" aria-selected="true" role="tab">Invoice Summary</a>
										</li>
										<li className="nav-item" role="presentation">
											<a className="nav-link text-active-primary pb-4" data-bs-toggle="tab" href="#kt_ecommerce_sales_invoice_history" aria-selected="false" role="tab" tabIndex="-1">Invoice History</a>
										</li>
										{customerInvoicePaymentDetails.length > 0 &&
											<li className="nav-item" role="presentation">
												<a className="nav-link text-active-primary pb-4" data-bs-toggle="tab" href="#kt_ecommerce_sales_invoice_payment_history" aria-selected="false" role="tab" tabIndex="-1">Payment History</a>
											</li>
										}
										{customerInvoiceDetails.e_invoice_doc.length > 0 &&
											<li className="nav-item" role="presentation">
												<a className="nav-link text-active-primary pb-4" data-bs-toggle="tab" href="#kt_ecommerce_e_sales_invoice_details" aria-selected="false" role="tab" tabIndex="-1">E-Invoice & EWB Details</a>
											</li>
										}
									</ul>
								</div>
								<div className="tab-content">
									<div className="tab-pane fade active show" id="kt_ecommerce_sales_invoice_summary" role="tab-panel">
										<div className="d-flex flex-column gap-7 gap-lg-10">
											<div className="d-flex flex-column flex-xl-row gap-7 gap-lg-10">
												<div className="card flex-equal">
													<div className="card-header">
														<div className="card-title">
															<h2>Invoice Details (#{customerInvoiceDetails.customer_invoice_number})</h2>
														</div>
													</div>
													<div className="card-body py-4">
														<div className="table-responsive">
															<table className="table align-middle table-row-bordered mb-0 fs-6 gy-5 min-w-300px">
																<tbody className="fw-semibold text-gray-600">
																	<tr>
																		<td className="text-muted">
																			<div className="d-flex align-items-center">
																				<span className="svg-icon svg-icon-2 me-2">
																					<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
																						<path opacity="0.3" d="M19 3.40002C18.4 3.40002 18 3.80002 18 4.40002V8.40002H14V4.40002C14 3.80002 13.6 3.40002 13 3.40002C12.4 3.40002 12 3.80002 12 4.40002V8.40002H8V4.40002C8 3.80002 7.6 3.40002 7 3.40002C6.4 3.40002 6 3.80002 6 4.40002V8.40002H2V4.40002C2 3.80002 1.6 3.40002 1 3.40002C0.4 3.40002 0 3.80002 0 4.40002V19.4C0 20 0.4 20.4 1 20.4H19C19.6 20.4 20 20 20 19.4V4.40002C20 3.80002 19.6 3.40002 19 3.40002ZM18 10.4V13.4H14V10.4H18ZM12 10.4V13.4H8V10.4H12ZM12 15.4V18.4H8V15.4H12ZM6 10.4V13.4H2V10.4H6ZM2 15.4H6V18.4H2V15.4ZM14 18.4V15.4H18V18.4H14Z" fill="currentColor"></path>
																						<path d="M19 0.400024H1C0.4 0.400024 0 0.800024 0 1.40002V4.40002C0 5.00002 0.4 5.40002 1 5.40002H19C19.6 5.40002 20 5.00002 20 4.40002V1.40002C20 0.800024 19.6 0.400024 19 0.400024Z" fill="currentColor"></path>
																					</svg>
																				</span>Status
																			</div>
																		</td>
																		<td className="fw-bold text-end">
																			<div style={{ position: "relative", display: "inline-block" }} >
																				<button className={
																					`py-2 me-1 rounded btn btn-sm btn-${customerInvoiceDetails.add_status === "CUSTOMER_INVOICE_PENDING_APPROVAL"
																						? "warning"
																						: customerInvoiceDetails.add_status === "CUSTOMER_INVOICE_FINALIZED"
																							? "success"
																							: "secondary"
																					}`
																				}
																					onClick={() => { setApprovalChainPopup(true); }}
																					onBlur={() => { setApprovalChainPopup(false) }}
																				>
																					{customerInvoiceDetails.add_status.replace("CUSTOMER_INVOICE", "").toLowerCase().replace(/_/g, ' ').replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())}
																				</button>
																				{
																					customerInvoiceDetails.approval_info.value.length > 0 &&
																					<div style={{ position: "absolute", right: "0px", top: "30px", boxShadow: "0 2px 5px 0 rgb(0 0 0 / 26%)", backgroundColor: "#FFFFFF", color: "black", padding: "1rem", width: "25rem", borderRadius: "0.5rem", transition: "all 0.25s ease-in-out", zIndex: 1, opacity: approvalChainPopup ? "1" : "0", visibility: approvalChainPopup ? "visible" : "hidden" }}>
																						{
																							customerInvoiceDetails.approval_info.type == "multilevel_approval" ?
																								<>
																									<div className='text-center border-bottom fs-4'>Multilevel Approval</div>
																									<div>
																										{
																											customerInvoiceDetails.approval_info.value.map((obj, i) => {
																												return (
																													<div key={i} className='mx-auto mt-2 gap-5' style={{ width: "95%", backgroundColor: "#edf0f2", borderRadius: "10px", display: "flex", alignItems: "center", padding: "10px", position: "relative", marginBottom: "30px" }}>
																														<div style={{ width: "30px", height: "30px", border: "5px #ffc700 solid", borderRadius: "10px" }}></div>
																														<div className='flex-grow-1 text-start'>
																															<div className='fs-4'>Level {obj.level}</div>
																															{
																																obj.user_value.map((val, j) => {
																																	return <div key={j} className="fs-7"><span className='bullet bg-primary me-2'></span>{val}</div>
																																})
																															}
																														</div>
																														<div style={{ position: "absolute", width: "2px", height: "30px", backgroundColor: "darkgray", top: "100%", left: "24px" }}></div>
																													</div>
																												)
																											})
																										}

																										<div className='mx-auto my-2 gap-20' style={{ width: "95%", backgroundColor: "#edf0f2", borderRadius: "10px", display: "flex", alignItems: "center", padding: "10px" }}>
																											<i className="fa-solid fa-star fs-1" style={{ color: "#ff8100" }} ></i>
																											<div className='fs-4'>Approved</div>
																										</div>
																									</div>
																								</>
																								:
																								customerInvoiceDetails.approval_info.type == "custom_approval" &&
																								<>
																									<div className='text-center border-bottom fs-4'>Custom Approval</div>
																									<div>
																										<div className='mx-auto mt-2 gap-5' style={{ width: "95%", backgroundColor: "#edf0f2", borderRadius: "10px", display: "flex", alignItems: "center", padding: "10px", position: "relative", marginBottom: "30px" }}>
																											<div style={{ width: "30px", height: "30px", border: "5px #ffc700 solid", borderRadius: "10px" }}></div>
																											<div className='flex-grow-1 text-start'>
																												<div className='fs-4'>{customerInvoiceDetails.approval_info.value[0].user_type}</div>
																												{
																													customerInvoiceDetails.approval_info.value[0].user_value.map((val, i) => {
																														return <div key={i} className="fs-7"><span className='bullet bg-primary me-2'></span>{val}</div>
																													})
																												}
																											</div>
																											<div style={{ position: "absolute", width: "2px", height: "30px", backgroundColor: "darkgray", top: "100%", left: "24px" }}></div>
																										</div>
																										<div className='mx-auto my-2 gap-20' style={{ width: "95%", backgroundColor: "#edf0f2", borderRadius: "10px", display: "flex", alignItems: "center", padding: "10px" }}>
																											<i className="fa-solid fa-star fs-1" style={{ color: "#ff8100" }} ></i>
																											<div className='fs-4'>Approved</div>
																										</div>
																									</div>
																								</>
																						}
																					</div>
																				}
																			</div>
																		</td>
																	</tr>
																	<tr>
																		<td className="text-muted">
																			<div className="d-flex align-items-center">
																				<span className="svg-icon svg-icon-2 me-2">
																					<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
																						<path opacity="0.3" d="M19 3.40002C18.4 3.40002 18 3.80002 18 4.40002V8.40002H14V4.40002C14 3.80002 13.6 3.40002 13 3.40002C12.4 3.40002 12 3.80002 12 4.40002V8.40002H8V4.40002C8 3.80002 7.6 3.40002 7 3.40002C6.4 3.40002 6 3.80002 6 4.40002V8.40002H2V4.40002C2 3.80002 1.6 3.40002 1 3.40002C0.4 3.40002 0 3.80002 0 4.40002V19.4C0 20 0.4 20.4 1 20.4H19C19.6 20.4 20 20 20 19.4V4.40002C20 3.80002 19.6 3.40002 19 3.40002ZM18 10.4V13.4H14V10.4H18ZM12 10.4V13.4H8V10.4H12ZM12 15.4V18.4H8V15.4H12ZM6 10.4V13.4H2V10.4H6ZM2 15.4H6V18.4H2V15.4ZM14 18.4V15.4H18V18.4H14Z" fill="currentColor"></path>
																						<path d="M19 0.400024H1C0.4 0.400024 0 0.800024 0 1.40002V4.40002C0 5.00002 0.4 5.40002 1 5.40002H19C19.6 5.40002 20 5.00002 20 4.40002V1.40002C20 0.800024 19.6 0.400024 19 0.400024Z" fill="currentColor"></path>
																					</svg>
																				</span>Invoice Date
																			</div>
																		</td>
																		<td className="fw-bold text-end">{moment(customerInvoiceDetails.invoice_date).format("ll")}</td>
																	</tr>
																	<tr>
																		<td className="text-muted">
																			<div className="d-flex align-items-center">
																				<span className="svg-icon svg-icon-2 me-2">
																					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																						<path opacity="0.3" d="M3.20001 5.91897L16.9 3.01895C17.4 2.91895 18 3.219 18.1 3.819L19.2 9.01895L3.20001 5.91897Z" fill="currentColor"></path>
																						<path opacity="0.3" d="M13 13.9189C13 12.2189 14.3 10.9189 16 10.9189H21C21.6 10.9189 22 11.3189 22 11.9189V15.9189C22 16.5189 21.6 16.9189 21 16.9189H16C14.3 16.9189 13 15.6189 13 13.9189ZM16 12.4189C15.2 12.4189 14.5 13.1189 14.5 13.9189C14.5 14.7189 15.2 15.4189 16 15.4189C16.8 15.4189 17.5 14.7189 17.5 13.9189C17.5 13.1189 16.8 12.4189 16 12.4189Z" fill="currentColor"></path>
																						<path d="M13 13.9189C13 12.2189 14.3 10.9189 16 10.9189H21V7.91895C21 6.81895 20.1 5.91895 19 5.91895H3C2.4 5.91895 2 6.31895 2 6.91895V20.9189C2 21.5189 2.4 21.9189 3 21.9189H19C20.1 21.9189 21 21.0189 21 19.9189V16.9189H16C14.3 16.9189 13 15.6189 13 13.9189Z" fill="currentColor"></path>
																					</svg>
																				</span>Reference Id
																			</div>
																		</td>
																		<td className="fw-bold text-end">{customerInvoiceDetails.reference_number !== "" ? customerInvoiceDetails.reference_number : "No reference number provided"}</td>
																	</tr>
																	<tr>
																		<td className="text-muted">
																			<div className="d-flex align-items-center">
																				<span className="svg-icon svg-icon-2 me-2">
																					<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
																						<path opacity="0.3" d="M19 3.40002C18.4 3.40002 18 3.80002 18 4.40002V8.40002H14V4.40002C14 3.80002 13.6 3.40002 13 3.40002C12.4 3.40002 12 3.80002 12 4.40002V8.40002H8V4.40002C8 3.80002 7.6 3.40002 7 3.40002C6.4 3.40002 6 3.80002 6 4.40002V8.40002H2V4.40002C2 3.80002 1.6 3.40002 1 3.40002C0.4 3.40002 0 3.80002 0 4.40002V19.4C0 20 0.4 20.4 1 20.4H19C19.6 20.4 20 20 20 19.4V4.40002C20 3.80002 19.6 3.40002 19 3.40002ZM18 10.4V13.4H14V10.4H18ZM12 10.4V13.4H8V10.4H12ZM12 15.4V18.4H8V15.4H12ZM6 10.4V13.4H2V10.4H6ZM2 15.4H6V18.4H2V15.4ZM14 18.4V15.4H18V18.4H14Z" fill="currentColor"></path>
																						<path d="M19 0.400024H1C0.4 0.400024 0 0.800024 0 1.40002V4.40002C0 5.00002 0.4 5.40002 1 5.40002H19C19.6 5.40002 20 5.00002 20 4.40002V1.40002C20 0.800024 19.6 0.400024 19 0.400024Z" fill="currentColor"></path>
																					</svg>
																				</span>Due Date
																			</div>
																		</td>
																		<td className="fw-bold text-end">{moment(customerInvoiceDetails.due_date).format("ll")}</td>
																	</tr>
																	<tr>
																		<td className="text-muted">
																			<div className="d-flex align-items-center">
																				<span className="svg-icon svg-icon-2 me-2">
																					<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
																						<path opacity="0.3" d="M19 3.40002C18.4 3.40002 18 3.80002 18 4.40002V8.40002H14V4.40002C14 3.80002 13.6 3.40002 13 3.40002C12.4 3.40002 12 3.80002 12 4.40002V8.40002H8V4.40002C8 3.80002 7.6 3.40002 7 3.40002C6.4 3.40002 6 3.80002 6 4.40002V8.40002H2V4.40002C2 3.80002 1.6 3.40002 1 3.40002C0.4 3.40002 0 3.80002 0 4.40002V19.4C0 20 0.4 20.4 1 20.4H19C19.6 20.4 20 20 20 19.4V4.40002C20 3.80002 19.6 3.40002 19 3.40002ZM18 10.4V13.4H14V10.4H18ZM12 10.4V13.4H8V10.4H12ZM12 15.4V18.4H8V15.4H12ZM6 10.4V13.4H2V10.4H6ZM2 15.4H6V18.4H2V15.4ZM14 18.4V15.4H18V18.4H14Z" fill="currentColor"></path>
																						<path d="M19 0.400024H1C0.4 0.400024 0 0.800024 0 1.40002V4.40002C0 5.00002 0.4 5.40002 1 5.40002H19C19.6 5.40002 20 5.00002 20 4.40002V1.40002C20 0.800024 19.6 0.400024 19 0.400024Z" fill="currentColor"></path>
																					</svg>
																				</span>Associated Organization GSTIN No.
																			</div>
																		</td>
																		<td className="fw-bold text-end">{customerInvoiceDetails?.organization_gstin_number || "N/A"}</td>
																	</tr>
																</tbody>
															</table>
														</div>
													</div>
												</div>
												<div className="card flex-equal">
													<div className="card-header">
														<div className="card-title">
															<h2>GSTIN Details</h2>
														</div>
													</div>
													<div className="card-body py-4">
														<div className="table-responsive">
															<table className="table align-middle table-row-bordered mb-0 fs-6 gy-5 min-w-300px">
																<tbody className="fw-semibold text-gray-600">
																	<tr>
																		<td className="text-muted">
																			<div className="d-flex align-items-center">
																				<span className="svg-icon svg-icon-2 me-2">
																					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																						<path opacity="0.3" d="M3.20001 5.91897L16.9 3.01895C17.4 2.91895 18 3.219 18.1 3.819L19.2 9.01895L3.20001 5.91897Z" fill="currentColor"></path>
																						<path opacity="0.3" d="M13 13.9189C13 12.2189 14.3 10.9189 16 10.9189H21C21.6 10.9189 22 11.3189 22 11.9189V15.9189C22 16.5189 21.6 16.9189 21 16.9189H16C14.3 16.9189 13 15.6189 13 13.9189ZM16 12.4189C15.2 12.4189 14.5 13.1189 14.5 13.9189C14.5 14.7189 15.2 15.4189 16 15.4189C16.8 15.4189 17.5 14.7189 17.5 13.9189C17.5 13.1189 16.8 12.4189 16 12.4189Z" fill="currentColor"></path>
																						<path d="M13 13.9189C13 12.2189 14.3 10.9189 16 10.9189H21V7.91895C21 6.81895 20.1 5.91895 19 5.91895H3C2.4 5.91895 2 6.31895 2 6.91895V20.9189C2 21.5189 2.4 21.9189 3 21.9189H19C20.1 21.9189 21 21.0189 21 19.9189V16.9189H16C14.3 16.9189 13 15.6189 13 13.9189Z" fill="currentColor"></path>
																					</svg>
																				</span>GST Treatment
																			</div>
																		</td>
																		<td className="fw-bold text-end">{gstDetails.gst_treatment}</td>
																	</tr>
																	{
																		(gstDetails.gst_treatment !== "Consumer" && gstDetails.gst_treatment !== "Unregistered Business") &&
																		<>
																			<tr>
																				<td className="text-muted">
																					<div className="d-flex align-items-center">
																						<span className="svg-icon svg-icon-2 me-2">
																							<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
																								<path opacity="0.3" d="M19 3.40002C18.4 3.40002 18 3.80002 18 4.40002V8.40002H14V4.40002C14 3.80002 13.6 3.40002 13 3.40002C12.4 3.40002 12 3.80002 12 4.40002V8.40002H8V4.40002C8 3.80002 7.6 3.40002 7 3.40002C6.4 3.40002 6 3.80002 6 4.40002V8.40002H2V4.40002C2 3.80002 1.6 3.40002 1 3.40002C0.4 3.40002 0 3.80002 0 4.40002V19.4C0 20 0.4 20.4 1 20.4H19C19.6 20.4 20 20 20 19.4V4.40002C20 3.80002 19.6 3.40002 19 3.40002ZM18 10.4V13.4H14V10.4H18ZM12 10.4V13.4H8V10.4H12ZM12 15.4V18.4H8V15.4H12ZM6 10.4V13.4H2V10.4H6ZM2 15.4H6V18.4H2V15.4ZM14 18.4V15.4H18V18.4H14Z" fill="currentColor"></path>
																								<path d="M19 0.400024H1C0.4 0.400024 0 0.800024 0 1.40002V4.40002C0 5.00002 0.4 5.40002 1 5.40002H19C19.6 5.40002 20 5.00002 20 4.40002V1.40002C20 0.800024 19.6 0.400024 19 0.400024Z" fill="currentColor"></path>
																							</svg>
																						</span>GSTIN
																					</div>
																				</td>
																				<td className="fw-bold text-end">{gstDetails.GstIn}</td>
																			</tr>
																			<tr>
																				<td className="text-muted">
																					<div className="d-flex align-items-center">
																						<span className="svg-icon svg-icon-2 me-2">
																							<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																								<path opacity="0.3" d="M3.20001 5.91897L16.9 3.01895C17.4 2.91895 18 3.219 18.1 3.819L19.2 9.01895L3.20001 5.91897Z" fill="currentColor"></path>
																								<path opacity="0.3" d="M13 13.9189C13 12.2189 14.3 10.9189 16 10.9189H21C21.6 10.9189 22 11.3189 22 11.9189V15.9189C22 16.5189 21.6 16.9189 21 16.9189H16C14.3 16.9189 13 15.6189 13 13.9189ZM16 12.4189C15.2 12.4189 14.5 13.1189 14.5 13.9189C14.5 14.7189 15.2 15.4189 16 15.4189C16.8 15.4189 17.5 14.7189 17.5 13.9189C17.5 13.1189 16.8 12.4189 16 12.4189Z" fill="currentColor"></path>
																								<path d="M13 13.9189C13 12.2189 14.3 10.9189 16 10.9189H21V7.91895C21 6.81895 20.1 5.91895 19 5.91895H3C2.4 5.91895 2 6.31895 2 6.91895V20.9189C2 21.5189 2.4 21.9189 3 21.9189H19C20.1 21.9189 21 21.0189 21 19.9189V16.9189H16C14.3 16.9189 13 15.6189 13 13.9189Z" fill="currentColor"></path>
																							</svg>
																						</span>Trade Name
																					</div>
																				</td>
																				<td className="fw-bold text-end">{gstDetails.trade_name !== "" ? gstDetails.trade_name : "No given trade name"}</td>
																			</tr>
																			<tr>
																				<td className="text-muted">
																					<div className="d-flex align-items-center">
																						<span className="svg-icon svg-icon-2 me-2">
																							<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																								<path opacity="0.3" d="M3.20001 5.91897L16.9 3.01895C17.4 2.91895 18 3.219 18.1 3.819L19.2 9.01895L3.20001 5.91897Z" fill="currentColor"></path>
																								<path opacity="0.3" d="M13 13.9189C13 12.2189 14.3 10.9189 16 10.9189H21C21.6 10.9189 22 11.3189 22 11.9189V15.9189C22 16.5189 21.6 16.9189 21 16.9189H16C14.3 16.9189 13 15.6189 13 13.9189ZM16 12.4189C15.2 12.4189 14.5 13.1189 14.5 13.9189C14.5 14.7189 15.2 15.4189 16 15.4189C16.8 15.4189 17.5 14.7189 17.5 13.9189C17.5 13.1189 16.8 12.4189 16 12.4189Z" fill="currentColor"></path>
																								<path d="M13 13.9189C13 12.2189 14.3 10.9189 16 10.9189H21V7.91895C21 6.81895 20.1 5.91895 19 5.91895H3C2.4 5.91895 2 6.31895 2 6.91895V20.9189C2 21.5189 2.4 21.9189 3 21.9189H19C20.1 21.9189 21 21.0189 21 19.9189V16.9189H16C14.3 16.9189 13 15.6189 13 13.9189Z" fill="currentColor"></path>
																							</svg>
																						</span>Legal Name
																					</div>
																				</td>
																				<td className="fw-bold text-end">{gstDetails.legal_name}</td>
																			</tr>
																		</>
																	}

																</tbody>
															</table>
														</div>
													</div>
												</div>
											</div>

											<div className="d-flex flex-column flex-xl-row gap-7 gap-lg-10">
												<div className="card flex-equal">
													<div className="card-header">
														<div className="card-title">
															<h2>Customer Details</h2>
														</div>
													</div>
													<div className="card-body py-4">
														<div className="table-responsive">
															<table className="table align-middle table-row-bordered mb-0 fs-6 gy-5 min-w-300px">
																<tbody className="fw-semibold text-gray-600">
																	<tr>
																		<td className="text-muted">
																			<div className="d-flex align-items-center">
																				<span className="svg-icon svg-icon-2 me-2">
																					<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
																						<path opacity="0.3" d="M16.5 9C16.5 13.125 13.125 16.5 9 16.5C4.875 16.5 1.5 13.125 1.5 9C1.5 4.875 4.875 1.5 9 1.5C13.125 1.5 16.5 4.875 16.5 9Z" fill="currentColor"></path>
																						<path d="M9 16.5C10.95 16.5 12.75 15.75 14.025 14.55C13.425 12.675 11.4 11.25 9 11.25C6.6 11.25 4.57499 12.675 3.97499 14.55C5.24999 15.75 7.05 16.5 9 16.5Z" fill="currentColor"></path>
																						<rect x="7" y="6" width="4" height="4" rx="2" fill="currentColor"></rect>
																					</svg>
																				</span>Customer Name
																			</div>
																		</td>
																		<td className="fw-bold text-end">{customerInvoiceDetails.customer_name}</td>
																	</tr>
																	<tr>
																		<td className="text-muted">
																			<div className="d-flex align-items-center">
																				<span className="svg-icon svg-icon-2 me-2">
																					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																						<path opacity="0.3" d="M21 19H3C2.4 19 2 18.6 2 18V6C2 5.4 2.4 5 3 5H21C21.6 5 22 5.4 22 6V18C22 18.6 21.6 19 21 19Z" fill="currentColor"></path>
																						<path d="M21 5H2.99999C2.69999 5 2.49999 5.10005 2.29999 5.30005L11.2 13.3C11.7 13.7 12.4 13.7 12.8 13.3L21.7 5.30005C21.5 5.10005 21.3 5 21 5Z" fill="currentColor"></path>
																					</svg>
																				</span>Customer Email
																			</div>
																		</td>
																		<td className="fw-bold text-end">{customerInvoiceDetails.customer_email !== "" ? customerInvoiceDetails.customer_email : "No Email-address added"}</td>
																	</tr>
																	<tr>
																		<td className="text-muted">
																			<div className="d-flex align-items-center">
																				<span className="svg-icon svg-icon-2 me-2">
																					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																						<path opacity="0.3" d="M21 19H3C2.4 19 2 18.6 2 18V6C2 5.4 2.4 5 3 5H21C21.6 5 22 5.4 22 6V18C22 18.6 21.6 19 21 19Z" fill="currentColor"></path>
																						<path d="M21 5H2.99999C2.69999 5 2.49999 5.10005 2.29999 5.30005L11.2 13.3C11.7 13.7 12.4 13.7 12.8 13.3L21.7 5.30005C21.5 5.10005 21.3 5 21 5Z" fill="currentColor"></path>
																					</svg>
																				</span>Additional User Email
																			</div>
																		</td>
																		<td className="fw-bold text-end">{customerInvoiceDetails.additional_user_email ? customerInvoiceDetails.additional_user_email : "No Additional user added"}</td>
																	</tr>
																</tbody>
															</table>
														</div>
													</div>
												</div>
												<div className="card flex-equal">
													<div className="card-header">
														<div className="card-title">
															<h2>Associated Details</h2>
														</div>
													</div>
													<div className="card-body py-4">
														<div className="table-responsive">
															<table className="table align-middle table-row-bordered mb-0 fs-6 gy-5 min-w-300px">
																<tbody className="fw-semibold text-gray-600">
																	<tr>
																		<td className="text-muted">
																			<div className="d-flex align-items-center">
																				<span className="svg-icon svg-icon-2 me-2">
																					<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
																						<path opacity="0.3" d="M19 3.40002C18.4 3.40002 18 3.80002 18 4.40002V8.40002H14V4.40002C14 3.80002 13.6 3.40002 13 3.40002C12.4 3.40002 12 3.80002 12 4.40002V8.40002H8V4.40002C8 3.80002 7.6 3.40002 7 3.40002C6.4 3.40002 6 3.80002 6 4.40002V8.40002H2V4.40002C2 3.80002 1.6 3.40002 1 3.40002C0.4 3.40002 0 3.80002 0 4.40002V19.4C0 20 0.4 20.4 1 20.4H19C19.6 20.4 20 20 20 19.4V4.40002C20 3.80002 19.6 3.40002 19 3.40002ZM18 10.4V13.4H14V10.4H18ZM12 10.4V13.4H8V10.4H12ZM12 15.4V18.4H8V15.4H12ZM6 10.4V13.4H2V10.4H6ZM2 15.4H6V18.4H2V15.4ZM14 18.4V15.4H18V18.4H14Z" fill="currentColor"></path>
																						<path d="M19 0.400024H1C0.4 0.400024 0 0.800024 0 1.40002V4.40002C0 5.00002 0.4 5.40002 1 5.40002H19C19.6 5.40002 20 5.00002 20 4.40002V1.40002C20 0.800024 19.6 0.400024 19 0.400024Z" fill="currentColor"></path>
																					</svg>
																				</span>Branch
																			</div>
																		</td>
																		<td className="fw-bold text-end">{customerInvoiceDetails.branch_name}</td>
																	</tr>
																	<tr>
																		<td className="text-muted">
																			<div className="d-flex align-items-center">
																				<span className="svg-icon svg-icon-2 me-2">
																					<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
																						<path opacity="0.3" d="M19 3.40002C18.4 3.40002 18 3.80002 18 4.40002V8.40002H14V4.40002C14 3.80002 13.6 3.40002 13 3.40002C12.4 3.40002 12 3.80002 12 4.40002V8.40002H8V4.40002C8 3.80002 7.6 3.40002 7 3.40002C6.4 3.40002 6 3.80002 6 4.40002V8.40002H2V4.40002C2 3.80002 1.6 3.40002 1 3.40002C0.4 3.40002 0 3.80002 0 4.40002V19.4C0 20 0.4 20.4 1 20.4H19C19.6 20.4 20 20 20 19.4V4.40002C20 3.80002 19.6 3.40002 19 3.40002ZM18 10.4V13.4H14V10.4H18ZM12 10.4V13.4H8V10.4H12ZM12 15.4V18.4H8V15.4H12ZM6 10.4V13.4H2V10.4H6ZM2 15.4H6V18.4H2V15.4ZM14 18.4V15.4H18V18.4H14Z" fill="currentColor"></path>
																						<path d="M19 0.400024H1C0.4 0.400024 0 0.800024 0 1.40002V4.40002C0 5.00002 0.4 5.40002 1 5.40002H19C19.6 5.40002 20 5.00002 20 4.40002V1.40002C20 0.800024 19.6 0.400024 19 0.400024Z" fill="currentColor"></path>
																					</svg>
																				</span>Warehouse
																			</div>
																		</td>
																		<td className="fw-bold text-end">{customerInvoiceDetails.name}</td>
																	</tr>
																	<tr>
																		<td className="text-muted">
																			<div className="d-flex align-items-center">
																				<span className="svg-icon svg-icon-2 me-2">
																					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																						<path d="M20 8H16C15.4 8 15 8.4 15 9V16H10V17C10 17.6 10.4 18 11 18H16C16 16.9 16.9 16 18 16C19.1 16 20 16.9 20 18H21C21.6 18 22 17.6 22 17V13L20 8Z" fill="currentColor"></path>
																						<path opacity="0.3" d="M20 18C20 19.1 19.1 20 18 20C16.9 20 16 19.1 16 18C16 16.9 16.9 16 18 16C19.1 16 20 16.9 20 18ZM15 4C15 3.4 14.6 3 14 3H3C2.4 3 2 3.4 2 4V13C2 13.6 2.4 14 3 14H15V4ZM6 16C4.9 16 4 16.9 4 18C4 19.1 4.9 20 6 20C7.1 20 8 19.1 8 18C8 16.9 7.1 16 6 16Z" fill="currentColor"></path>
																					</svg>
																				</span>Place Of Supply
																			</div>
																		</td>
																		<td className="fw-bold text-end">{customerInvoiceDetails.place_of_supply}</td>
																	</tr>
																	<tr>
																		<td className="text-muted">
																			<div className="d-flex align-items-center">
																				<span className="svg-icon svg-icon-2 me-2">
																					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																						<path opacity="0.3" d="M21.6 11.2L19.3 8.89998V5.59993C19.3 4.99993 18.9 4.59993 18.3 4.59993H14.9L12.6 2.3C12.2 1.9 11.6 1.9 11.2 2.3L8.9 4.59993H5.6C5 4.59993 4.6 4.99993 4.6 5.59993V8.89998L2.3 11.2C1.9 11.6 1.9 12.1999 2.3 12.5999L4.6 14.9V18.2C4.6 18.8 5 19.2 5.6 19.2H8.9L11.2 21.5C11.6 21.9 12.2 21.9 12.6 21.5L14.9 19.2H18.2C18.8 19.2 19.2 18.8 19.2 18.2V14.9L21.5 12.5999C22 12.1999 22 11.6 21.6 11.2Z" fill="currentColor"></path>
																						<path d="M11.3 9.40002C11.3 10.2 11.1 10.9 10.7 11.3C10.3 11.7 9.8 11.9 9.2 11.9C8.8 11.9 8.40001 11.8 8.10001 11.6C7.80001 11.4 7.50001 11.2 7.40001 10.8C7.20001 10.4 7.10001 10 7.10001 9.40002C7.10001 8.80002 7.20001 8.4 7.30001 8C7.40001 7.6 7.7 7.29998 8 7.09998C8.3 6.89998 8.7 6.80005 9.2 6.80005C9.5 6.80005 9.80001 6.9 10.1 7C10.4 7.1 10.6 7.3 10.8 7.5C11 7.7 11.1 8.00005 11.2 8.30005C11.3 8.60005 11.3 9.00002 11.3 9.40002ZM10.1 9.40002C10.1 8.80002 10 8.39998 9.90001 8.09998C9.80001 7.79998 9.6 7.70007 9.2 7.70007C9 7.70007 8.8 7.80002 8.7 7.90002C8.6 8.00002 8.50001 8.2 8.40001 8.5C8.40001 8.7 8.30001 9.10002 8.30001 9.40002C8.30001 9.80002 8.30001 10.1 8.40001 10.4C8.40001 10.6 8.5 10.8 8.7 11C8.8 11.1 9 11.2001 9.2 11.2001C9.5 11.2001 9.70001 11.1 9.90001 10.8C10 10.4 10.1 10 10.1 9.40002ZM14.9 7.80005L9.40001 16.7001C9.30001 16.9001 9.10001 17.1 8.90001 17.1C8.80001 17.1 8.70001 17.1 8.60001 17C8.50001 16.9 8.40001 16.8001 8.40001 16.7001C8.40001 16.6001 8.4 16.5 8.5 16.4L14 7.5C14.1 7.3 14.2 7.19998 14.3 7.09998C14.4 6.99998 14.5 7 14.6 7C14.7 7 14.8 6.99998 14.9 7.09998C15 7.19998 15 7.30002 15 7.40002C15.2 7.30002 15.1 7.50005 14.9 7.80005ZM16.6 14.2001C16.6 15.0001 16.4 15.7 16 16.1C15.6 16.5 15.1 16.7001 14.5 16.7001C14.1 16.7001 13.7 16.6 13.4 16.4C13.1 16.2 12.8 16 12.7 15.6C12.5 15.2 12.4 14.8001 12.4 14.2001C12.4 13.3001 12.6 12.7 12.9 12.3C13.2 11.9 13.7 11.7001 14.5 11.7001C14.8 11.7001 15.1 11.8 15.4 11.9C15.7 12 15.9 12.2 16.1 12.4C16.3 12.6 16.4 12.9001 16.5 13.2001C16.6 13.4001 16.6 13.8001 16.6 14.2001ZM15.4 14.1C15.4 13.5 15.3 13.1 15.2 12.9C15.1 12.6 14.9 12.5 14.5 12.5C14.3 12.5 14.1 12.6001 14 12.7001C13.9 12.8001 13.8 13.0001 13.7 13.2001C13.6 13.4001 13.6 13.8 13.6 14.1C13.6 14.7 13.7 15.1 13.8 15.4C13.9 15.7 14.1 15.8 14.5 15.8C14.8 15.8 15 15.7 15.2 15.4C15.3 15.2 15.4 14.7 15.4 14.1Z" fill="currentColor"></path>
																					</svg>
																				</span>Currency
																			</div>
																		</td>
																		<td className="fw-bold text-end">{invoiceCurrencyDetails.currency_code}</td>
																	</tr>
																</tbody>
															</table>
														</div>
													</div>
												</div>
											</div>

											<div className="d-flex flex-column flex-xl-row gap-7 gap-lg-10">
												<div className="card card-flush flex-equal">
													<div className="position-absolute end-0 opacity-10" style={{ top: "15%" }}>
														<img src="/assets/media/icons/duotune/ecommerce/ecm001.svg" className="w-125px" alt="Location Icon" />
													</div>
													<div className="card-header">
														<div className="card-title">
															<h2>Billing Address</h2>
														</div>
													</div>
													<div className="card-body py-3">
														<div className="address-info">
															{
																billingAddress.address_line1 &&
																<div className="address">
																	<i className="fa-solid fa-location-crosshairs"></i> {billingAddress.address_line1}
																</div>
															}
															{
																billingAddress.address_line2 &&
																<div className="address">
																	<i className="fa-solid fa-location-crosshairs"></i> {billingAddress.address_line2}
																</div>
															}
															<div className="location">
																<i className="fas fa-map-marker-alt"></i> {billingAddress.city}, {billingAddress.state}
															</div>
															<div className="pincode">
																<i className="fas fa-thumbtack"></i> {billingAddress.pincode}
															</div>
															<div className="country">
																<i className="fas fa-globe"></i> {billingAddress.country}
															</div>
														</div>
													</div>
												</div>
												<div className="card card-flush flex-equal">
													<div className="position-absolute end-0 opacity-10" style={{ top: "15%" }}>
														<img src="/assets/media/icons/duotune/ecommerce/ecm006.svg" className="w-125px" alt="Location Icon" />
													</div>
													<div className="card-header">
														<div className="card-title">
															<h2>Shipping Address</h2>
														</div>
													</div>
													<div className="card-body py-3">
														<div className="address-info">
															{
																shippingAddress.address_line1 &&
																<div className="address">
																	<i className="fa-solid fa-location-crosshairs"></i> {shippingAddress.address_line1}
																</div>
															}
															{
																shippingAddress.address_line2 &&
																<div className="address">
																	<i className="fa-solid fa-location-crosshairs"></i> {shippingAddress.address_line2}
																</div>
															}
															<div className="location">
																<i className="fas fa-map-marker-alt"></i> {shippingAddress.city}, {shippingAddress.state}
															</div>
															<div className="pincode">
																<i className="fas fa-thumbtack"></i> {shippingAddress.pincode}
															</div>
															<div className="country">
																<i className="fas fa-globe"></i> {shippingAddress.country}
															</div>
														</div>
													</div>
												</div>
											</div>

											<div className="card">
												<div className="card-header align-items-center py-5 gap-2 gap-md-5">
													{customerInvoiceDetails.add_status === 'CUSTOMER_INVOICE_WAREHOUSE' ? (
														<div className="d-flex flex-wrap flex-stack gap-5 gap-lg-10">
															<ul className="nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semibold mb-lg-n2 me-auto" role="tablist">
																<li className="nav-item" role="presentation">
																	<a className={`nav-link text-active-primary pb-4 ${itemTab === 'orderedItems' ? 'active' : ''}`} onClick={() => setItemTab('orderedItems')} role="tab" style={{ cursor: 'pointer' }} > Invocied Items </a>
																</li>
																<li className="nav-item" role="presentation">
																	<a className={`nav-link text-active-primary pb-4 ${itemTab === 'itemDetails' ? 'active' : ''}`} onClick={() => setItemTab('itemDetails')} role="tab" style={{ cursor: 'pointer' }} tabIndex="-1" > Item Details </a>
																</li>
															</ul>
														</div>
													) : (
														<div className="card-title">
															<h2>Invoiced Items</h2>
														</div>
													)}
												</div>
												<div className="card-body py-4">
													{
														itemTab === 'orderedItems' &&
														<>
															{
																itemDetails.length > 0 ?
																	<div className="d-flex justify-content-between flex-column">
																		<div className="table-responsive border-bottom mb-9">
																			<table className="table align-middle table-row-dashed text-nowrap fs-6 gy-5 mb-0">
																				<thead>
																					<tr className="border-bottom fs-6 fw-bold text-gray-700">
																						<th className="min-w-150px">Products</th>
																						<th className="min-w-150px">Rate<br />(Tax Exclusive)</th>
																						<th className="min-w-150px">Rate<br />(Tax Inclusive)</th>
																						<th className="min-w-150px">QTY</th>
																						<th className="min-w-150px">Discount</th>
																						<th className="min-w-150px">Total Amt.<br />Excl.</th>
																						<th className="min-w-150px">Tax Percentage</th>
																						<th className="min-w-150px">Tax Amount</th>
																						<th className="min-w-150px text-end pb-2">Total</th>
																					</tr>
																				</thead>
																				<tbody className="fw-semibold text-gray-600">
																					{itemDetails.map((Obj, index) => {
																						return (
																							<tr key={index}>
																								<td>
																									<div className="fw-bold">
																										<div className="fw-bold">{Obj.item_name}</div>
																										{Obj.tax_code !== "" && <span className="badge badge-light-primary me-2">{Obj.tax_code_type}: {Obj.tax_code}</span>}
																									</div>
																								</td>
																								{/* <td>{currencySymbol} {Math.round(Obj.TAX_Exclusive_Price * decimalPlace) / decimalPlace}</td> */}
																								<td>{invoiceCurrencyDetails.currency_symbol} {formatNumber(Obj.TAX_Exclusive_Price, { ...formatNumberOptions, currencyFormat: invoiceCurrencyDetails.format, decimalPlaces: invoiceCurrencyDetails.decimal_place })}</td>
																								{/* <td>{invoiceCurrencyDetails.currency_symbol} {Math.round(Obj.TAX_Inclusive_Price * decimalPlace) / decimalPlace}</td> */}
																								<td>{invoiceCurrencyDetails.currency_symbol} {formatNumber(Obj.TAX_Inclusive_Price, { ...formatNumberOptions, currencyFormat: invoiceCurrencyDetails.format, decimalPlaces: invoiceCurrencyDetails.decimal_place })}</td>
																								<td>{Obj.quantity}</td>
																								<td>
																									<div className="fw-bold">
																										{
																											(() => {
																												let da = Obj.discount_type === "amount" ? Obj.discount_unit : Obj.rate * Obj.quantity * Obj.discount_unit / 100
																												return (
																													<>
																														<div className="fw-bold">
																															{invoiceCurrencyDetails.currency_symbol} {formatNumber(da, { ...formatNumberOptions, currencyFormat: invoiceCurrencyDetails.format, decimalPlaces: invoiceCurrencyDetails.decimal_place })}
																														</div>
																														{Obj.discount_type !== "amount" && <span className="badge badge-light-primary me-2">{Obj.discount_unit} %</span>}
																													</>
																												)
																											})()
																										}
																									</div>
																								</td>
																								<td>{invoiceCurrencyDetails.currency_symbol} {formatNumber(((Obj.quantity * Obj.rate) - (Obj.discount_type == "amount" ? Obj.discount_unit : Obj.quantity * Obj.rate * Obj.discount_unit / 100)), { ...formatNumberOptions, currencyFormat: invoiceCurrencyDetails.format, decimalPlaces: invoiceCurrencyDetails.decimal_place })}</td>
																								{Obj.taxable === 1 ? <td><div className="ms-5"><div>{Obj.tax_group_name} ({Obj.tax_group_percentage}%)</div><div className="mb-8">
																									{Obj.tax_group_details.map((Obj1, index1) => {
																										return (
																											<span key={index1} className="badge badge-light-primary me-2">{Obj1.tax_name} ({Obj1.tax_percentage}%)</span>
																										)
																									})}
																								</div></div></td> : <td>---</td>}
																								<td>{invoiceCurrencyDetails.currency_symbol} {formatNumber((Obj.taxable == 0 ? 0 : ((Obj.quantity * Obj.rate) - (Obj.discount_type == "amount" ? Obj.discount_unit : Obj.quantity * Obj.rate * Obj.discount_unit / 100)) * (Obj.tax_group_percentage / 100)), { ...formatNumberOptions, currencyFormat: invoiceCurrencyDetails.format, decimalPlaces: invoiceCurrencyDetails.decimal_place })}</td>
																								<td className="text-end">{invoiceCurrencyDetails.currency_symbol} {formatNumber((((Obj.quantity * Obj.rate) - (Obj.discount_type == "amount" ? Obj.discount_unit : Obj.quantity * Obj.rate * Obj.discount_unit / 100)) + (Obj.taxable == 0 ? 0 : ((Obj.quantity * Obj.rate) - (Obj.discount_type == "amount" ? Obj.discount_unit : Obj.quantity * Obj.rate * Obj.discount_unit / 100)) * (Obj.tax_group_percentage / 100))), { ...formatNumberOptions, currencyFormat: invoiceCurrencyDetails.format, decimalPlaces: invoiceCurrencyDetails.decimal_place })}</td>
																							</tr>
																						)
																					})}

																				</tbody>
																			</table>
																		</div>
																		<div className="row flex-column-reverse flex-md-row">
																			<div className="col-md-6 py-1">
																				<div className="mw-md-200px">
																					<div className="fw-semibold mb-3 text-dark">Tax Calculation</div>
																					{taxDetails.map((Obj, index) => {
																						return (
																							<div key={index} className="d-flex flex-stack text-gray-800 mb-3">
																								<div className="fw-semibold pe-5">{Obj.tax_name} ({Obj.tax_percentage}%):</div>
																								<div className="text-end">{invoiceCurrencyDetails.currency_symbol} {formatNumber(Obj.tax_amount, { ...formatNumberOptions, currencyFormat: invoiceCurrencyDetails.format, decimalPlaces: invoiceCurrencyDetails.decimal_place })}</div>
																							</div>
																						)
																					})}
																				</div>
																			</div>

																			<div className="col-md-6 py-1">
																				<div className="mw-md-300px ms-md-auto">
																					<div className="mb-3 d-flex justify-content-between">
																						<span className="fw-semibold text-gray-600">Subtotal:</span>
																						<span className="fw-bold text-gray-800">{invoiceCurrencyDetails.currency_symbol} {formatNumber(subTotal, { ...formatNumberOptions, currencyFormat: invoiceCurrencyDetails.format, decimalPlaces: invoiceCurrencyDetails.decimal_place })}</span>
																					</div>
																					<div className="mb-3 d-flex justify-content-between">
																						<span className="fw-semibold text-gray-600">Tax Percentage {customerInvoiceDetails.tax_percentage !== null && <>({customerInvoiceDetails.tax_name}-{customerInvoiceDetails.tax_percentage}%)</>}</span>
																						<span className="fw-bold text-gray-800">{invoiceCurrencyDetails.currency_symbol} {formatNumber((customerInvoiceDetails.tax_category == "TDS" ? itemDetails.reduce((p, o) => { return p + ((o.quantity * o.rate) - (o.discount_type == "amount" ? o.discount_unit : o.quantity * o.rate * o.discount_unit / 100)) }, 0) : subTotal) * (customerInvoiceDetails.tax_id == null ? 0 : parseFloat(customerInvoiceDetails.tax_percentage)) / 100, { ...formatNumberOptions, currencyFormat: invoiceCurrencyDetails.format, decimalPlaces: invoiceCurrencyDetails.decimal_place })}</span>
																					</div>
																					<div className="mb-3 d-flex justify-content-between">
																						<span className="fw-semibold text-gray-600">{adjustmentText}</span>
																						<span className="fw-bold text-gray-800">{invoiceCurrencyDetails.currency_symbol} {formatNumber(adjustmentValue, { ...formatNumberOptions, currencyFormat: invoiceCurrencyDetails.format, decimalPlaces: invoiceCurrencyDetails.decimal_place })}</span>
																					</div>
																					<div className="d-flex justify-content-between">
																						<span className="fw-semibold text-gray-600">Total</span>
																						<span className="fw-bold text-gray-800">{invoiceCurrencyDetails.currency_symbol} {formatNumber(customerInvoiceDetails.grand_total, { ...formatNumberOptions, currencyFormat: invoiceCurrencyDetails.format, decimalPlaces: invoiceCurrencyDetails.decimal_place })}</span>
																					</div>
																				</div>
																			</div>
																		</div>
																	</div>
																	:
																	<div className='text-center'><span className='text-gray-600 fs-2tx'>No items present</span></div>
															}

														</>

													}

													{
														itemTab === 'itemDetails' && (
															<div className="d-flex justify-content-between flex-column">
																{warehouseDetails.add_status === 'CUSTOMER_WAREHOUSE_PROCESSING_INIT' ? (
																	<div className="alert alert-info" role="alert">
																		Process the items to warehouse to view details
																	</div>
																) : (
																	<div className="table-responsive border-bottom mb-9">
																		<table className="table align-middle table-row-dashed fs-6 gy-5 mb-0">
																			<thead>
																				<tr className="border-bottom fs-6 fw-bold text-muted">
																					<th className="min-w-100px">Item Name</th>
																					<th className="min-w-70px">Type</th>
																					<th className="min-w-70px">Quantity</th>
																					<th className="min-w-70px">Stock Type</th>
																					<th className="min-w-70px">Details</th>
																				</tr>
																			</thead>
																			<tbody className="fw-semibold text-gray-600">
																				{warehouseItemArray.map((item, index) => {
																					return (
																						<tr key={index}>
																							<td>
																								<div className="fw-bold">{item.item_name}</div>
																							</td>
																							<td>{item.item_type}</td>
																							<td>{item.quantity}</td>
																							<td>{item.item_stock_type === "Track Serial Number" ? "Serial Type Product" : item.item_stock_type === "Track Batches" ? "Batch Type Product" : "None Type"}</td>
																							<td>
																								{item.item_stock_type === "Track Serial Number" ? (
																									item.item_data ? (
																										<button className='btn btn-sm btn-info rounded' onClick={() => { setItemsModalShow(true); setItemsData(item.item_data) }}>Serials</button>
																									) : "NA"
																								) : (
																									item.item_stock_type === "Track Batches" ? (
																										item.item_data ? (
																											<button className='btn btn-sm btn-info rounded' onClick={() => { setItemsModalShow(true); setItemsData(item.item_data) }}>Batch Details</button>
																										) : "NA"
																									) : "NA"
																								)}
																							</td>
																						</tr>
																					);
																				})}
																			</tbody>
																		</table>
																	</div>
																)}
															</div>
														)
													}

												</div>
											</div>

											<div className="card">
												<div className="card-header">
													<div className="card-title">
														<h2>Additional Information</h2>
													</div>
												</div>
												<div className="card-body pt-0">
													<div className="table-responsive">
														<table className="table align-middle table-row-bordered mb-0 fs-6 gy-5 min-w-300px">
															<tbody className="fw-semibold text-gray-600">
																<tr>
																	<td className="text-muted">
																		<div className="d-flex align-items-center">
																			<span className="svg-icon svg-icon-2 me-2">
																				<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
																					<path opacity="0.3" d="M19 3.40002C18.4 3.40002 18 3.80002 18 4.40002V8.40002H14V4.40002C14 3.80002 13.6 3.40002 13 3.40002C12.4 3.40002 12 3.80002 12 4.40002V8.40002H8V4.40002C8 3.80002 7.6 3.40002 7 3.40002C6.4 3.40002 6 3.80002 6 4.40002V8.40002H2V4.40002C2 3.80002 1.6 3.40002 1 3.40002C0.4 3.40002 0 3.80002 0 4.40002V19.4C0 20 0.4 20.4 1 20.4H19C19.6 20.4 20 20 20 19.4V4.40002C20 3.80002 19.6 3.40002 19 3.40002ZM18 10.4V13.4H14V10.4H18ZM12 10.4V13.4H8V10.4H12ZM12 15.4V18.4H8V15.4H12ZM6 10.4V13.4H2V10.4H6ZM2 15.4H6V18.4H2V15.4ZM14 18.4V15.4H18V18.4H14Z" fill="currentColor"></path>
																					<path d="M19 0.400024H1C0.4 0.400024 0 0.800024 0 1.40002V4.40002C0 5.00002 0.4 5.40002 1 5.40002H19C19.6 5.40002 20 5.00002 20 4.40002V1.40002C20 0.800024 19.6 0.400024 19 0.400024Z" fill="currentColor"></path>
																				</svg>
																			</span>Term
																		</div>
																	</td>
																	<td className="fw-bold text-end">{customerInvoiceDetails.term == null ? "No term period provided" : (customerInvoiceDetails.term.term_name + "---" + customerInvoiceDetails.term.term_days + " days")}</td>
																</tr>
																<tr>
																	<td className="text-muted">
																		<div className="d-flex align-items-center">
																			<span className="svg-icon svg-icon-2 me-2">
																				<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
																					<path opacity="0.3" d="M19 3.40002C18.4 3.40002 18 3.80002 18 4.40002V8.40002H14V4.40002C14 3.80002 13.6 3.40002 13 3.40002C12.4 3.40002 12 3.80002 12 4.40002V8.40002H8V4.40002C8 3.80002 7.6 3.40002 7 3.40002C6.4 3.40002 6 3.80002 6 4.40002V8.40002H2V4.40002C2 3.80002 1.6 3.40002 1 3.40002C0.4 3.40002 0 3.80002 0 4.40002V19.4C0 20 0.4 20.4 1 20.4H19C19.6 20.4 20 20 20 19.4V4.40002C20 3.80002 19.6 3.40002 19 3.40002ZM18 10.4V13.4H14V10.4H18ZM12 10.4V13.4H8V10.4H12ZM12 15.4V18.4H8V15.4H12ZM6 10.4V13.4H2V10.4H6ZM2 15.4H6V18.4H2V15.4ZM14 18.4V15.4H18V18.4H14Z" fill="currentColor"></path>
																					<path d="M19 0.400024H1C0.4 0.400024 0 0.800024 0 1.40002V4.40002C0 5.00002 0.4 5.40002 1 5.40002H19C19.6 5.40002 20 5.00002 20 4.40002V1.40002C20 0.800024 19.6 0.400024 19 0.400024Z" fill="currentColor"></path>
																				</svg>
																			</span>Subject
																		</div>
																	</td>
																	<td className="fw-bold text-end">{customerInvoiceDetails.subject !== "" ? customerInvoiceDetails.subject : "No subject added"}</td>
																</tr>
																<tr>
																	<td className="text-muted">
																		<div className="d-flex align-items-center">
																			<span className="svg-icon svg-icon-2 me-2">
																				<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
																					<path opacity="0.3" d="M19 3.40002C18.4 3.40002 18 3.80002 18 4.40002V8.40002H14V4.40002C14 3.80002 13.6 3.40002 13 3.40002C12.4 3.40002 12 3.80002 12 4.40002V8.40002H8V4.40002C8 3.80002 7.6 3.40002 7 3.40002C6.4 3.40002 6 3.80002 6 4.40002V8.40002H2V4.40002C2 3.80002 1.6 3.40002 1 3.40002C0.4 3.40002 0 3.80002 0 4.40002V19.4C0 20 0.4 20.4 1 20.4H19C19.6 20.4 20 20 20 19.4V4.40002C20 3.80002 19.6 3.40002 19 3.40002ZM18 10.4V13.4H14V10.4H18ZM12 10.4V13.4H8V10.4H12ZM12 15.4V18.4H8V15.4H12ZM6 10.4V13.4H2V10.4H6ZM2 15.4H6V18.4H2V15.4ZM14 18.4V15.4H18V18.4H14Z" fill="currentColor"></path>
																					<path d="M19 0.400024H1C0.4 0.400024 0 0.800024 0 1.40002V4.40002C0 5.00002 0.4 5.40002 1 5.40002H19C19.6 5.40002 20 5.00002 20 4.40002V1.40002C20 0.800024 19.6 0.400024 19 0.400024Z" fill="currentColor"></path>
																				</svg>
																			</span>Customer Notes
																		</div>
																	</td>
																	<td className="fw-bold text-end">{customerInvoiceDetails.customer_notes !== "" ? customerInvoiceDetails.customer_notes : "No notes added"}</td>
																</tr>
																<tr>
																	<td className="text-muted">
																		<div className="d-flex align-items-center">
																			<span className="svg-icon svg-icon-2 me-2">
																				<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
																					<path opacity="0.3" d="M19 3.40002C18.4 3.40002 18 3.80002 18 4.40002V8.40002H14V4.40002C14 3.80002 13.6 3.40002 13 3.40002C12.4 3.40002 12 3.80002 12 4.40002V8.40002H8V4.40002C8 3.80002 7.6 3.40002 7 3.40002C6.4 3.40002 6 3.80002 6 4.40002V8.40002H2V4.40002C2 3.80002 1.6 3.40002 1 3.40002C0.4 3.40002 0 3.80002 0 4.40002V19.4C0 20 0.4 20.4 1 20.4H19C19.6 20.4 20 20 20 19.4V4.40002C20 3.80002 19.6 3.40002 19 3.40002ZM18 10.4V13.4H14V10.4H18ZM12 10.4V13.4H8V10.4H12ZM12 15.4V18.4H8V15.4H12ZM6 10.4V13.4H2V10.4H6ZM2 15.4H6V18.4H2V15.4ZM14 18.4V15.4H18V18.4H14Z" fill="currentColor"></path>
																					<path d="M19 0.400024H1C0.4 0.400024 0 0.800024 0 1.40002V4.40002C0 5.00002 0.4 5.40002 1 5.40002H19C19.6 5.40002 20 5.00002 20 4.40002V1.40002C20 0.800024 19.6 0.400024 19 0.400024Z" fill="currentColor"></path>
																				</svg>
																			</span>Terms and Conditions
																		</div>
																	</td>
																	<td className="fw-bold text-end">{customerInvoiceDetails.terms_and_conditions !== "" ? customerInvoiceDetails.terms_and_conditions : "No terms or conditions provided"}</td>
																</tr>
															</tbody>
														</table>
													</div>
												</div>
											</div>
										</div>
									</div>

									<div className="tab-pane fade" id="kt_ecommerce_sales_invoice_history" role="tab-panel">
										<div className="d-flex flex-column gap-7 gap-lg-10">
											<div className="card card-flush py-4 flex-row-fluid">
												<div className="card-header">
													<div className="card-title">
														<h2>Invoice History</h2>
													</div>
												</div>

												<div className="card-body pt-0">
													{
														customerInvoiceHistoryDetails.length > 0 &&
														<div className="table-responsive">
															<table className="table align-middle table-row-dashed fs-6 gy-5 mb-0">
																<thead>
																	<tr className="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
																		<th className="min-w-100px">Date Added</th>
																		<th className="min-w-175px">Comment</th>
																		<th className="min-w-70px">Invoice Status</th>
																		<th className="min-w-100px">Customer Notifed</th>
																	</tr>
																</thead>
																<tbody className="fw-semibold text-gray-600">
																	{
																		customerInvoiceHistoryDetails.map((Obj, index) => {
																			return (
																				<tr key={index}>
																					<td>{moment(Obj.timestamp).format("ll")}</td>
																					<td>{Obj.operation_message}</td>
																					<td>
																						<div className={`badge badge-${Obj.customer_invoice_status === "CUSTOMER_INVOICE_PENDING_APPROVAL"
																							? "warning"
																							: Obj.customer_invoice_status === "CUSTOMER_INVOICE_FINALIZED"
																								? "success"
																								: "secondary"}
																									`}>
																							{Obj.customer_invoice_status.replace("CUSTOMER_INVOICE", "").toLowerCase().replace(/_/g, ' ').replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())}
																						</div>
																					</td>
																					<td>No</td>
																				</tr>
																			)
																		})
																	}
																</tbody>
															</table>
														</div>
													}
												</div>
											</div>
										</div>
									</div>

									<div className="tab-pane fade" id="kt_ecommerce_sales_invoice_payment_history" role="tab-panel">
										<div className="d-flex flex-column gap-7 gap-lg-10">
											<div className="card card-flush py-4 flex-row-fluid">
												<div className="card-header">
													<div className="card-title">
														<h2>Payment History</h2>
													</div>
												</div>
												{/* {console.log("customerInvoicePaymentDetails", customerInvoicePaymentDetails)} */}
												<div className="card-body pt-0">
													{
														customerInvoicePaymentDetails.length > 0 &&
														<div className="table-responsive">
															<table className="table align-middle table-row-dashed fs-6 gy-5 mb-0">
																<thead>
																	<tr className="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
																		<th className="min-w-70px">Sl No.</th>
																		<th className="min-w-175px">Payment Amount</th>
																		<th className="min-w-70px">Added By</th>
																		<th className="min-w-100px">Timestamp</th>
																		<th className="min-w-100px">Status</th>
																	</tr>
																</thead>
																<tbody className="fw-semibold text-gray-600">
																	{
																		customerInvoicePaymentDetails.map((Obj, index) => {
																			return (
																				<tr key={index}>
																					<td>{index + 1}</td>
																					<td>{invoiceCurrencyDetails.currency_symbol}{Obj.payment_amount}</td>
																					<td><span className="badge badge-secondary">{Obj.user_id}</span></td>
																					<td>{moment(Obj.log_date_time).format("lll")}</td>
																					<td>
																						<div className={`badge badge-${Obj.log_status === "Cancelled"
																							? "danger"
																							: Obj.log_status === "Paid"
																								? "success"
																								: Obj.log_status === "Pending"
																									? "warning"
																									: "secondary"}
																									`}>
																							{Obj.log_status}
																						</div>
																					</td>
																				</tr>
																			)
																		})
																	}
																</tbody>
															</table>
														</div>
													}
												</div>
											</div>
										</div>
									</div>

									{customerInvoiceDetails.e_invoice_doc.length > 0 &&
										<div className="tab-pane fade" id="kt_ecommerce_e_sales_invoice_details" role="tab-panel">
											<div className="d-flex flex-column gap-7 gap-lg-10">
												<div className="card card-flush py-4 flex-row-fluid">
													<div className="card-header">
														<div className="card-title">
															<h2>E-Invoice Details</h2>
														</div>
													</div>

													<div className="card-body pt-0">
														<div className="row">
															<div className="col-md-4">
																<div className="d-flex flex-column">
																	<span className="text-muted fw-semibold">Invoice Type:</span>
																	<span className="text-dark fs-5">{customerInvoiceDetails.e_invoice_doc[0].invoice_type}</span>
																</div>
															</div>
															<div className="col-md-4">
																<div className="d-flex flex-column">
																	<span className="text-muted fw-semibold">Date:</span>
																	<span className="text-dark fs-5">{moment(customerInvoiceDetails.e_invoice_doc[0].typestamp).format('ll')}</span>
																</div>
															</div>
															<div className="col-md-4">
																<div className="d-flex flex-column">
																	<span className="text-muted fw-semibold">Status:</span>
																	{/* <span className="py-2 me-1 rounded badge badge-success">{customerInvoiceDetails.e_invoice_doc[0].e_invoice_status}</span> */}
																	<StatusBadge status={customerInvoiceDetails.e_invoice_doc[0].e_invoice_status} entity={""} className={"py-2 me-1 rounded"} />
																</div>
															</div>
															{/* <div className="col-md-3">
															<div className="d-flex flex-column">
																<span className="text-muted fw-semibold">Amount:</span>
																<span className="text-dark fs-5">$1,200.00</span>
															</div>
														</div> */}
														</div>
													</div>

												</div>

												<div className="card card-flush py-4 flex-row-fluid">
													<div className="card-header">
														<div className="card-title">
															<h2>EWB Details</h2>
														</div>
													</div>

													<div className="card-body pt-0">
														<div className="row mb-3">
															<div className="col-md-4">
																<div className="d-flex flex-column">
																	<span className="text-muted fw-semibold">E-Way bill No:</span>
																	<span className="text-dark fs-5">{customerInvoiceDetails.e_invoice_doc[0].e_invoice_data.EwbNo}</span>
																</div>
															</div>
															<div className="col-md-4">
																<div className="d-flex flex-column">
																	<span className="text-muted fw-semibold">E-Way bill Date:</span>
																	<span className="text-dark fs-5">{moment(customerInvoiceDetails.e_invoice_doc[0].e_invoice_data.EwbDt).format('ll')}</span>
																</div>
															</div>
															<div className="col-md-4">
																<div className="d-flex flex-column">
																	<span className="text-muted fw-semibold">Valid till:</span>
																	<span className="text-dark fs-5">{moment(customerInvoiceDetails.e_invoice_doc[0].e_invoice_data.EwbValidTill).format('ll')}</span>
																</div>
															</div>
														</div>
														<div className="row">
															<div className="col-md-8">
																<div className="d-flex flex-column">
																	<span className="text-muted fw-semibold">Irn:</span>
																	<span className="text-dark fs-5">{customerInvoiceDetails.e_invoice_doc[0].e_invoice_data.Irn}</span>
																</div>
															</div>
															<div className="col-md-4">
																<div className="d-flex flex-column">
																	<span className="text-muted fw-semibold">Acknowledgement Date:</span>
																	<span className="text-dark fs-5">{moment(customerInvoiceDetails.e_invoice_doc[0].e_invoice_data.AckDt).format('ll')}</span>
																</div>
															</div>
														</div>
													</div>

												</div>
											</div>
										</div>
									}

								</div>
							</div>

						</>
						: state == 2 ?
							<div className="card modal-body pt-0 pb-15 px-5 px-xl-20">
								<img src="/images/loader-06.svg" alt="" style={loaderstyle} />
							</div>
							:
							<PageError />
					}
				</div>
			</div >

			<Modal show={invoiceStatusModalShow} onHide={() => { handleInvoiceStatusModalClose(); }} centered>
				<Modal.Header>
					<Modal.Title>Invoice Status</Modal.Title>
					<div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { handleInvoiceStatusModalClose(); }}>
						<span className="svg-icon svg-icon-1">
							<svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
								<g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
									<rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
									<rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
								</g>
							</svg>
						</span>
					</div>
				</Modal.Header>
				<Modal.Body>
					{invoiceStatusApiState === false ?
						<div className="text-center">
							<span>Loading...</span>
							<svg width="50" height="15" viewBox="0 45 100 10">
								<g transform="translate(20 50)"><circle cx="0" cy="0" r="6" fill="#e15b64"><animateTransform attributeName="transform" type="scale" begin="-0.375s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform></circle></g>
								<g transform="translate(40 50)"><circle cx="0" cy="0" r="6" fill="#f8b26a"><animateTransform attributeName="transform" type="scale" begin="-0.25s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform></circle></g>
								<g transform="translate(60 50)"><circle cx="0" cy="0" r="6" fill="#abbd81"><animateTransform attributeName="transform" type="scale" begin="-0.125s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform></circle></g>
								<g transform="translate(80 50)"><circle cx="0" cy="0" r="6" fill="#81a3bd"><animateTransform attributeName="transform" type="scale" begin="0s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform></circle></g>
							</svg>
						</div>
						: <>{invoiceStatus !== null &&
							<>
								{invoiceStatus.data.length > 0 &&
									<div className="table-responsive border-bottom mb-9">
										<table className="table align-middle table-row-dashed fs-6 gy-5 mb-0">
											<thead>
												<tr className="border-bottom fs-6 fw-bold text-muted">
													<th className="min-w-100px">Products</th>
													<th className="min-w-100px">Remaining Quantity</th>
												</tr>
											</thead>
											<tbody className="fw-semibold text-gray-600">
												{invoiceStatus.data.map((Obj, index) => {
													return (
														<tr key={index}>
															<td>
																<div className="fw-bold">
																	<div className="fw-bold">{Obj.item_name}</div>

																</div>
															</td>
															<td>{Obj.quantity}</td>
														</tr>
													)
												})}

											</tbody>
										</table>
									</div>
								}
								{invoiceStatus.operation == "success" ?
									<h3>Are you sure about mark as completed?</h3>
									:
									invoiceStatus.message == "incomplete warehouse processing" ?
										<h3>Incomplete warehouse processing needs to be completed.</h3>
										:
										<h3>The incomplete delivery challan needs to be completed.</h3>
								}
							</>
						}
						</>
					}
				</Modal.Body>
				<Modal.Footer>
					<button className="btn btn-danger rounded" onClick={() => { handleInvoiceStatusModalClose(); }}>Close</button>
					{(invoiceStatus !== null && invoiceStatus.operation == "success") &&
						<button className="btn btn-success rounded" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState} onClick={() => { markAsComplete() }}>
							<span className="indicator-label">Proceed</span>
							<span className="indicator-progress">Please wait...
								<span className="spinner-border spinner-border-sm align-middle ms-2"></span>
							</span>
						</button>}
				</Modal.Footer>
			</Modal >

			<Modal show={itemsModalShow} onHide={() => { setItemsModalShow(false); setItemsData([]); }} centered>
				<Modal.Header>
					<Modal.Title>Item Details</Modal.Title>
					<div className="btn btn-sm btn-icon btn-active-color-danger" onClick={() => { setItemsModalShow(false); setItemsData([]); }}>
						<span className="svg-icon svg-icon-1">
							<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-circle-fill" viewBox="0 0 16 16">
								<path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
							</svg>
						</span>
					</div>
				</Modal.Header>
				<Modal.Body>
					<div className='container d-flex flex-wrap gap-2'>
						{
							itemsData.map((obj, indx) => {
								// console.log(itemsData);
								return (
									<div key={indx}>
										<span className='fw-bold fs-4 p-2 badge bg-primary'>
											{obj.serial_name ? obj.serial_name : null}
											{obj.batch_reference ? `${obj.batch_reference} - Qty: ${obj.unit}` : null}
										</span>
									</div>
								);
							})
						}
					</div>
				</Modal.Body>
			</Modal>

			<Modal show={printModalShow} onHide={() => { setPrintModalShow(false) }} centered className="bg-transparent">
				<Modal.Body className="position-relative">
					<div className="position-absolute top-0 end-0 p-2">
						<div onClick={() => { setPrintModalShow(false) }} className="cursor-pointer">
							<i className="bi bi-x-circle fs-4 text-danger"></i>
						</div>
					</div>

					<div className="d-flex align-items-center justify-content-center gap-3 mb-4">
						<label className="mb-0 fw-semibold">No. of copies :</label>
						<select
							className="form-select form-select-sm"
							style={{ width: "80px" }}
							value={noOfCopies}
							onChange={(e) => setNoOfCopies(Number(e.target.value))}
						>
							<option value={1}>1</option>
							<option value={2}>2</option>
						</select>
					</div>
					<div className='fw-bold container d-flex justify-content-center gap-5'>
						<div>Choose file type to print :</div>
						<button className='btn btn-sm btn-info' onClick={() => { handleOperation('print') }} data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState}>
							<i className="bi bi-file-earmark-pdf fs-4 fw-bold"></i> A4
						</button>
						<button className='btn btn-sm btn-warning' onClick={() => { handleOperationBill('print') }}>
							<i className="bi bi-receipt fs-4 fw-bold"></i>Bill
						</button>
					</div>
				</Modal.Body>
			</Modal>

			<Modal show={downloadModalShow} onHide={() => { setDownloadModalShow(false) }} centered className="bg-transparent">
				<Modal.Body className="position-relative">
					<div className="position-absolute top-0 end-0 p-2">
						<div onClick={() => { setDownloadModalShow(false) }} className="cursor-pointer">
							<i className="bi bi-x-circle fs-4 text-danger"></i>
						</div>
					</div>
					<div className='fw-bold container d-flex align-items-center gap-5'>
						<div>Choose file type to Download :</div>
						{
							write &&
							<button type="button" className="btn btn-sm btn-info" data-kt-indicator={loading ? "on" : "off"} disabled={loading} onClick={generateDownload}>
								<span className="indicator-label"><i className="bi bi-file-earmark-pdf fs-4 fw-bold"></i>A4</span>
								<span className="indicator-progress">Loading...
									<span className="spinner-border spinner-border-sm align-middle ms-2"></span>
								</span>
							</button>
						}
						<button className='btn btn-sm btn-warning'>Download as Other</button>
					</div>
				</Modal.Body>
			</Modal>
		</>);

};

export default ViewCustomerInvoice;

